import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { MUIFilterListIcon } from "../../../../../assets/svgToIconCovert";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import usePrevious from '../../../../../utils/usePrevious';
import { useWindowDimensions } from '../../../../../utils/useWindowDimensions';
import _ from 'lodash';
import moment from 'moment';
import './HotelBaseComplianceFilterSection.css';

import { CreateDropDown, CreateDatePicker } from "../../../Common/interfaces";
import CustomDrawer from "../../../Common/CustomDrawer/CustomDrawer";
import CustomModal from '../../../Common/CustomModal/CustomModal';
import QMSErrorHandle from '../../../../auxil/QMSErrorHandle';

import commonConfig from '../../../../commonConfig.json';
import { indexesMapping, indexesFilterType } from "./indexesMapping.json";
import { compViewskeyMapper, structureIndexData, getUnique, processDateConfigs, getParentMapping, getHierarchy, pageFilterColSpan, getIterativeDependencies } from '../../../../../utils/generalProcessing';
import * as appPermissionActions from '../../../../../store/actions/appPermissionActions';
import * as qmsApiActions from '../../../../../store/actions/qmsApi';
import * as controlledComponentsActions from '../../../../../store/actions/controlledComponentsActions';
import * as actions from '../../../../../store/actions/indexes';
import { Badge, Button, Col, Row } from 'antd';


let dropDownConfigs = commonConfig.dropdownProps;
let datePickerConfigs = commonConfig.datePickerProps;
let drawerConfigs = commonConfig.drawerProps;
let modalConfigs = commonConfig.modalProps;
let apps = commonConfig.apps;
let envs = commonConfig.envs;
let env = process.env["REACT_APP_HMG"];
let customTabView = commonConfig.customTabView
let hotelStatusTypes = commonConfig.hotelStatusTypes
let softLiveTypes = commonConfig.softLiveTypes

const HotelBaseComplianceFilterSection = props => {
    const [currentHMG, setCurrentHMG] = useState({ hmg: "", entityId: "" });
    const [currentSol, setCurrentSol] = useState({});
    const [currentSolSecTriggerData, setCurrentSolSecTriggerData] = useState({}); //all secondary trigger data without filteration based on current tab
    const [currentIndexes, setCurrentIndexes] = useState({});
    const [currentProj, setCurrentProj] = useState({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {} }); //filter data
    const [selectedProjData, setSelectedProjData] = useState({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {} });//currently selected filter data
    const [selectedExtraProjData, setSelectedExtraProjData] = useState({ appConfigSoftLiveType: {}, altSearchIdx: {} });
    const [appliedSelectedProjData, setAppliedSelectedProjData] = useState({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {}, appConfigSoftLiveType: {}, altSearchIdx: {} }); // go button applied selected filter data
    const [initialSelectedProjData, setInitialSelectedProjData] = useState({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {}, appConfigSoftLiveType: {}, altSearchIdx: {} }); // onload,hmg change,solution change selected filter data
    const [go, setGo] = useState({ dataApplied: false, isDisabled: true }); // go button of large screens
    const [reset, setReset] = useState({ visibility: false, resetApplied: false }); // reset button
    const [triggeredFilterData, setTriggeredFilterData] = useState({}); // onChange trigger data from filter
    const [filterObjs, setFilterObjs] = useState([]);
    const [styledFilter, setStyledFilter] = useState({ pageFilters: [], drawerFilters: [] });
    const [drawerData, setDrawerData] = useState({ visibility: false, dataApplied: false, dataReset: false, submitBtnDisable: true, closeBtnDisable: false, dataAppliedCount: 0 }); // drawer data on mobile view
    const [modalData, setModalData] = useState({ visibility: false, type: "", title: "", data: {} }); // modal data for grouping
    const [errorObject, setErrorObject] = useState({ err: false, errCode: "", errType: "", errMsg: "", display: false, app: apps.COMPLIANCE }); // error handling object

    const compSearchData = useRef({
        hotelIdx: null,
        bDateIdx: null,
        reportCatIdx: null,
        reportIdx: null,
        appConfigSoftLiveType: null,
        managementGroup: null,
        solution: null,
        pms: null,
        userEmail: null,
        searchData: {},
        selectedCustomViewTab: null,
        isCustomTriggersAvailable: false,
        isNewRequest: false,
        paginationReset: false,
        isInitialReq: false,
        // selectedCustomViewTriggerIndex: null,
        // selectedCustomViewTriggerIndexValue: [],
        // selectedCustomViewTriggerScheduleType: null,
    }); // filter data to transfer for retrival of table data

    const filterUpdatedData = useRef({
        // filterDataReplace: false, //not used // when replace data -(eg: when tab change previous selected tab to have applied data saved if not cliked on Go, drawer cancel to have previous selected data)
        updatedData: {}, //grouping data - updated list (can be used in future for ProjData changes not only group data changes)
        changedData: {}, //grouping data - item updated (can be used in future for ProjData changes not only group data changes)
        selectedProjDataChanged: { //instead updating the state of selectedProjData on tab change maintain on refs to avoid unnecessary reloads (eg: when tab change previous selected tab to have applied data saved if not cliked on Go, drawer cancel to have previous selected data)
            isChanged: false,
            changedData: {}
        },
        selectedExtraProjDataChanged: { //instead updating the state of selectedExtraProjData on tab change maintain on refs to avoid unnecessary reloads(eg: when tab change previous selected tab to have applied data saved if not cliked on Go, drawer cancel to have previous selected data)
            isChanged: false,
            changedData: {}
        },
        // initialSelectedProjData: { //onLoad data for Clear/Reset btn clicks //TODO -move to state and have same structure as selected proj data

        // },
        initialSelectedProjDataOnDrawerOpen: {}, // project data selection, captured when opening the drawer - used for drawer cancel btn click to reset if any change done

        // isDrawerFilterChangeReq: false //need to check if this is necessary if can tackle by initialSelectedProjData_desktop_drawer
    })

    const isFilterOnChange = useRef(false);

    const dispatch = useDispatch();

    const complianceMainTabActive = useSelector((state) => state.appPermissionsReducer.complianceMainTabData.active, shallowEqual);
    const prevComplianceMainTabActive = usePrevious(complianceMainTabActive);
    const prevCurrentHMG = usePrevious(currentHMG);
    const compliancePermissions = useSelector((state) => state.appPermissionsReducer.compliancePermissions, shallowEqual);
    const common = useSelector((state) => state.common, shallowEqual);
    const appConfigData = useSelector((state) => state.qmsApi.appConfigData, shallowEqual);
    const holisticData = useSelector((state) => state.qmsApi.holisticHotelData, shallowEqual);
    const categoryReportData = useSelector((state) => state.qmsApi.complianceReportsCategoriesData, shallowEqual);
    const loggedUserData = useSelector((state) => state.userDetailReducer, shallowEqual);
    const groupingModalData = useSelector((state) => state.groupingModalReducer, shallowEqual);
    const isControlledFiltersOpen = useSelector((state) => state.controlledComponentsReducer.isControlledFiltersOpen, shallowEqual);

    const { width } = useWindowDimensions();

    const printError = (newError) => {
        setErrorObject(newError)
    }

    const resetSessData = () => { //reset the session data came through url params
        let tempcompSearchParams = { ...props.compSearchParams };
        let filteredSearchParams = Object.fromEntries(Object.entries(tempcompSearchParams).filter(([k, v]) => k === 'pms'));
        props.compSearchParamsCallback(filteredSearchParams);
        return;
    }

    const handleHMG = (selHmgKey) => {
        let hmgList = props.projectDetails.filter(p => {
            let hmgCusView = p.hmg_custom_views.map(v => compViewskeyMapper(v, "VALUE", "KEY"));
            return hmgCusView.includes(complianceMainTabActive) === true
        }).map(p => ({ key: p.hmg_name, value: p.hmg_name, data: { entityId: p.entityId, custom_views: p.hmg_custom_views } }));
        if (hmgList.length !== 0) {
            let selectedHMG = undefined;
            let err = false;
            if (selHmgKey !== undefined) { // if hmg changed
                let tempfilter = hmgList.find(h => h.key === selHmgKey);
                if (tempfilter !== undefined) {
                    selectedHMG = { hmg: tempfilter.key, entityId: tempfilter.data.entityId };
                } else {
                    err = true;
                    printError({
                        display: true,
                        err: true,
                        errCode: "Error",
                        errType: "messageErr",
                        errMsg: "No matching selected Hotel Management Group on the list",
                        app: apps.COMPLIANCE
                    });
                }
            } else if (props.compSearchParams !== null &&
                (props.compSearchParams.triggerSchedule !== undefined &&
                    props.compSearchParams.triggerSchedule === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")) &&
                (props.compSearchParams.hmgName !== undefined && props.compSearchParams.hmgName !== "")) { // use URL param to set hmg
                let tempfilter = hmgList.find(h => h.key === props.compSearchParams.hmgName);
                if (tempfilter !== undefined) {
                    selectedHMG = { hmg: tempfilter.key, entityId: tempfilter.data.entityId };
                } else {
                    err = true;
                    printError({
                        display: true,
                        err: true,
                        errCode: "Error",
                        errType: "messageErr",
                        errMsg: "No matching selected Hotel Management Group on the list",
                        app: apps.COMPLIANCE
                    });
                }
            } else if (currentHMG.hmg !== "" && currentHMG.entityId !== "") { //if already set use it (if tab change)
                if (hmgList.find(h => h.key === currentHMG.hmg) !== undefined) {
                    selectedHMG = currentHMG;
                } else {
                    err = true;
                    printError({
                        display: true,
                        err: true,
                        errCode: "Error",
                        errType: "messageErr",
                        errMsg: "No matching selected Hotel Management Group on the list",
                        app: apps.COMPLIANCE
                    });
                }

            } else { // set default - 1st hmg from the list
                selectedHMG = { hmg: hmgList[0].key, entityId: hmgList[0].data.entityId };
            }

            if (err !== true) {
                if (compliancePermissions.compAllowCustomView === true) {
                    let tempfilter = [];
                    for (const type of props.allHMGCustomViewTypes) {
                        let f = hmgList.filter(h => h.key === selectedHMG.hmg).filter(sh => sh.data.custom_views.includes(type) === false)
                        if (f.length !== 0) {
                            tempfilter.push(compViewskeyMapper(type, "VALUE", "KEY"));
                        }
                    }
                    dispatch(appPermissionActions.setComplianceMainDisabledTab(tempfilter));
                } else {
                    let tempfilter = [];
                    let f = props.allHMGCustomViewTypes.filter(v => v !== "Daily");
                    if (f.length !== 0) {
                        tempfilter = f.map(t => compViewskeyMapper(t, "VALUE", "KEY"))
                    }
                    dispatch(appPermissionActions.setComplianceMainDisabledTab(tempfilter));
                }

                let hmgIndx = {
                    name: "HMG",
                    order: 1,
                    type: "text",
                    valuesType: "HMG",
                    values: hmgList,
                    selectedValue: selectedHMG.hmg,
                    indexCategory: "HMG",
                    onChangeFn: setTriggeredFilterData
                }

                let filterObjArr = [...filterObjs];
                let fIndex = _.findIndex(filterObjArr, (e => e.key === 'comp_search_' + hmgIndx.name));
                if (fIndex === -1) {
                    filterObjArr = [...filterObjArr, CreateDropDown(hmgIndx)]
                } else {
                    filterObjArr[fIndex] = CreateDropDown(hmgIndx)
                }
                _.sortBy(filterObjArr, [props.indexOrder]);
                setFilterObjs(filterObjArr);

                setCurrentHMG(selectedHMG);
            }
        }
        return;
    }

    const unmountFilterObjsExcept = (exceptObj) => {
        let copyFilterObjArr = [...filterObjs];
        if (exceptObj === "HMG") {
            if (copyFilterObjArr.length > 1) {
                let newFilterObjs = copyFilterObjArr.filter(f => f.key === 'comp_search_HMG');
                if (newFilterObjs.length !== 0) {
                    setFilterObjs(newFilterObjs);
                }
            }
        }
        //in multiple solution - for Solution dropdown required
        return;
    }
    const handleSol = (selSolKey) => {
        let allowedProjects = ["PNA"];
        let err = false;
        compSearchData.current.hotelIdx = null;
        compSearchData.current.bDateIdx = null;
        compSearchData.current.reportCatIdx = null;
        compSearchData.current.reportIdx = null;
        compSearchData.current.appConfigSoftLiveType = null;
        compSearchData.current.managementGroup = null;
        compSearchData.current.solution = null;
        compSearchData.current.pms = null;
        compSearchData.current.userEmail = null;
        compSearchData.current.searchData = {};
        compSearchData.current.isCustomTriggersAvailable = false;

        if (props.projectDetails.length !== 0 && currentHMG.hmg !== "" && currentHMG.entityId !== "") {
            let selectedHMGData = props.projectDetails.filter(item => item.hmg_name === currentHMG.hmg);
            if (selectedHMGData[0].projectList.length > 0) {
                let validProjects = selectedHMGData[0].projectList.filter(proj => { //get allowed projects (pna)
                    return allowedProjects.includes(proj.solution) === true
                });
                if (validProjects.length !== 0) {
                    let sortedSolution = _.sortedUniq(validProjects.map(proj => {
                        let projCusView = proj.project_custom_views.map(v => compViewskeyMapper(v, "VALUE", "KEY"));
                        if (projCusView.includes(complianceMainTabActive) === true) {
                            return { key: proj.solution, value: proj.solution, data: proj }
                        }
                    }));

                    if (sortedSolution.length !== 0) {
                        let selectedSol = undefined;
                        let onchangeAction = false;
                        if (selSolKey) { // COMMENTS OUT - not needed since not visible currently
                            // let tempfilter = sortedSolution.find(p => p.data.project_id == compSearchParams.projId);
                            // if (tempfilter !== undefined) {
                            //     selectedSol = { sol: tempfilter.key, projId: tempfilter.data.project_id };
                            // } else {
                            //     err = true;
                            // printError({
                            //     display: true,
                            //     err: true,
                            //     errCode: "Error",
                            //     errType: "messageErr",
                            //     errMsg: "No matching selected Project on the list",
                            //     app: apps.COMPLIANCE
                            // });
                            // }
                        } else if (props.compSearchParams !== null &&
                            (props.compSearchParams.triggerSchedule !== undefined &&
                                props.compSearchParams.triggerSchedule === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")) &&
                            (props.compSearchParams.projId !== undefined && props.compSearchParams.projId !== "")) { // use URL param to set project
                            let tempfilter = sortedSolution.find(p => p.data.project_id === props.compSearchParams.projId);
                            if (tempfilter !== undefined) {
                                selectedSol = { sol: tempfilter.key, projId: tempfilter.data.project_id, projData: tempfilter.data };
                            } else {
                                err = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: "No matching selected Project on the list",
                                    app: apps.COMPLIANCE
                                });
                            }
                        } else if (!_.isEmpty(currentSol) &&
                            currentSol[complianceMainTabActive] !== undefined &&
                            currentSol[complianceMainTabActive].sol !== "" &&
                            currentSol[complianceMainTabActive].projId !== "") { //if already set use it (if tab change or hmg change)
                            if (sortedSolution.find(s => s.data.project_id === currentSol[complianceMainTabActive].projId) !== undefined) { //tab change
                                selectedSol = currentSol[complianceMainTabActive];
                            }
                            else { // hmg change
                                selectedSol = { sol: sortedSolution[0].key, projId: sortedSolution[0].data.project_id, projData: sortedSolution[0].data };
                            }

                        } else { // set default - 1st sol from the list
                            selectedSol = { sol: sortedSolution[0].key, projId: sortedSolution[0].data.project_id, projData: sortedSolution[0].data };
                        }
                        if (err !== true) {
                            /* **COMMENTS OUT till enable showing solution dropdown
                            if (!onchangeAction) {
                                let solIndx = {
                                    name: "Solution",
                                    order: 2,
                                    type: "text",
                                    valuesType: "Solution",
                                    values: sortedSolution,
                                    selectedValue: selectedSol.sol,
                                    indexCategory: "Solution",
                                    onChangeFn: setTriggeredFilterData
                                }
                                let filterObjArr = [...filterObjs];
                                let fIndex = _.findIndex(filterObjArr, (e => e.key === 'comp_search_' + solIndx.name));
                                if (fIndex === -1) {
                                    // return [...oldFilterObjs,CreateDropDown(hmgIndx)]
                                    filterObjArr = [...filterObjArr, CreateDropDown(solIndx)]
                                } else {
                                    filterObjArr[fIndex] = CreateDropDown(solIndx)
                                }
                                _.sortBy(filterObjArr, [props.indexOrder]);
                                setFilterObjs(filterObjArr);
                            }*/

                            if (selectedSol.projData.mypOnly) {
                                err = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: "HMG has myP only hotel(s)",
                                    app: apps.COMPLIANCE
                                });
                            } else {
                                setCurrentSol({ ...currentSol, [complianceMainTabActive]: selectedSol });
                                setCurrentSolSecTriggerData({ ...currentSolSecTriggerData, [complianceMainTabActive]: selectedSol.projData.project_custom_view_trigger_indexes });
                            }
                        }

                    } else {
                        err = true;
                        printError({
                            display: true,
                            err: true,
                            errCode: "Error",
                            errType: "messageErr",
                            errMsg: "No Solutions for the selected view",
                            app: apps.COMPLIANCE
                        });
                    }

                } else { //No allowed solutions
                    err = true;
                    printError({
                        display: true,
                        err: true,
                        errCode: "Error",
                        errType: "messageErr",
                        errMsg: "No Projects for the allowed solution(s)",
                        app: apps.COMPLIANCE
                    });
                }
            } else { // No projects for the selected HMG
                err = true;
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No Projects for the selected Hotel Management Group",
                    app: apps.COMPLIANCE
                });
            }
        }
        return;
    }

    const fetchExtraData = (type, data) => {
        switch (type) {
            case 'getHolisticData_hotel':
                dispatch(qmsApiActions.getHolisticData(data));
                break;
            case 'getReportCategoryData_hotel':
                dispatch(qmsApiActions.getComplianceHotelReportCategoryData(data));
                break;
            // case 'getReportData_hotel_category':
            //     dispatch(qmsApiActions.getComplianceHotelReportCategoryData(data));
            //     break;
            default:
                break;
        }
        return;
    }
    const processAppconfigData = () => {
        let copiedCurrentIndexes = { ...currentIndexes };
        if (!_.isEmpty(copiedCurrentIndexes) && copiedCurrentIndexes[complianceMainTabActive] !== undefined) { // if only tab change not for 1st time
            compSearchData.current.isNewRequest = false; // these 3 should depend on large screen page filter change and drawer filter changes
            compSearchData.current.paginationReset = false;
            compSearchData.current.isInitialReq = false;
            if (filterUpdatedData.current.selectedExtraProjDataChanged.isChanged === true) {
                setSelectedExtraProjData(filterUpdatedData.current.selectedExtraProjDataChanged.changedData);
                // reset after setting
                filterUpdatedData.current.selectedExtraProjDataChanged.changedData = {};
                filterUpdatedData.current.selectedExtraProjDataChanged.isChanged = false;
            }
            if (currentIndexes[complianceMainTabActive].l1_Indexes.length !== 0 && currentProj.l1_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l1_Indexes[complianceMainTabActive])) {
                if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                    if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l1_Indexes'] !== undefined) {
                        processCurrentIndexes('l1_Indexes', 'updated');
                    } else {
                        handleIndexProjData('l1_Indexes');
                    }
                } else {
                    handleIndexProjData('l1_Indexes');
                }
            } else {
                if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                    if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                        processCurrentIndexes('independentIndexes', 'updated');
                    } else {
                        handleIndexProjData('independentIndexes');
                    }
                } else {
                    handleIndexProjData('independentIndexes');
                }
            }
        } else { // if a change from hmg or solution level or tab(for the 1st time)
            compSearchData.current.isNewRequest = true;
            compSearchData.current.paginationReset = true;
            compSearchData.current.isInitialReq = true;
            if (common.error === null && !_.isEmpty(appConfigData)) {
                let complianceLevel = appConfigData.compliance_level;
                let complianceStatus = appConfigData.compliance_status;
                let appConfigSoftLiveType = appConfigData.softLiveType;
                let searchableIndexes = appConfigData.searchableIndexes;
                let uniqueIndexes = appConfigData.uniqueIndexes;
                let alternateSearchIndexes = appConfigData.alternateSearchIndexes;
                let indexSortOrder = appConfigData.sort;
                /* ** let indexDependingLevels  = appConfigData.indexDependingLevels; // TODO :future to config on SM for multi level dependancies*/


                if (searchableIndexes.length === 0 || uniqueIndexes.length === 0 || alternateSearchIndexes.length === 0) {
                    printError({
                        display: true,
                        err: true,
                        errCode: "Error",
                        errType: "messageErr",
                        errMsg: "Required application settings not configured properly in System Manager",
                        app: apps.COMPLIANCE
                    });
                } else {
                    dispatch(appPermissionActions.setComplianceConfig({
                        complianceLevel: complianceLevel,
                        complianceStatus: complianceStatus,
                    }))

                    let temptindexes = { l1_Indexes: [], l2_Indexes: [], l3_Indexes: [], l4_Indexes: [], l5_Indexes: [], independentIndexes: [] }

                    /* --- permission for indexes - <ADD AS REQUIRED> --- */
                    if (!compliancePermissions.compAllowReportCategory) { //if report category index not allowed - remove from indexes list
                        searchableIndexes = searchableIndexes.filter(c => c.valuesType !== "Report Category");
                    }
                    if (!compliancePermissions.compAllowReportName) { //if report name index not allowed - remove from indexes list
                        searchableIndexes = searchableIndexes.filter(c => c.valuesType !== "Report");
                    }

                    /* --- set the order of indexes --- */
                    searchableIndexes = searchableIndexes.map(s => {
                        let f = indexSortOrder.find(i => i.indexId === s._id);
                        return (f !== undefined ? { ...s, order: (f.order + 2) } : s)

                    })

                    let tempSearchableIndexes = searchableIndexes.map(s => {
                        return {
                            "id": s._id,
                            "indexName": s.name,
                        }
                    })
                    let indexMap = getParentMapping(tempSearchableIndexes, indexesMapping[currentSol[complianceMainTabActive].sol]);
                    let indexMapWithLevel = getHierarchy(indexMap);
                    for (const currIndex of searchableIndexes) {
                        let modifiedCurrIndex = [currIndex];
                        let currMap = indexMapWithLevel.find(f => f.id === currIndex._id);
                        modifiedCurrIndex = modifiedCurrIndex.map(m => ({ ...m, 'indexDepends': currMap.parentId }));
                        if (currMap !== undefined) {
                            switch (currMap.level) {
                                case 1:
                                    temptindexes.l1_Indexes = temptindexes.l1_Indexes.concat(modifiedCurrIndex);
                                    break;
                                case 2:
                                    temptindexes.l2_Indexes = temptindexes.l2_Indexes.concat(modifiedCurrIndex);
                                    break;
                                case 3:
                                    temptindexes.l3_Indexes = temptindexes.l3_Indexes.concat(modifiedCurrIndex);
                                    break;
                                case 4:
                                    temptindexes.l4_Indexes = temptindexes.l4_Indexes.concat(modifiedCurrIndex);
                                    break;
                                case 5:
                                    temptindexes.l5_Indexes = temptindexes.l5_Indexes.concat(modifiedCurrIndex);
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    //TODO :Should change after level config introduces
                    if (temptindexes.l1_Indexes.length !== 0) {
                        /* --- fetch extra data if required for level1 indexes --- */
                        if (temptindexes.l1_Indexes.filter(c => c.valuesType === "Hotels").length !== 0) {
                            if (compliancePermissions.allowHolistc) {
                                fetchExtraData('getHolisticData_hotel', {
                                    managementGroup: currentHMG.hmg,
                                    project: currentSol[complianceMainTabActive].sol
                                });
                            } else {
                                console.log("holistic not allowed");
                            }
                        }

                    } else { // independent indexes available
                        temptindexes.independentIndexes = searchableIndexes.map(m => ({ ...m, 'indexDepends': null }));
                        /* --- fetch extra data if required for level1 indexes --- */
                        if (temptindexes.independentIndexes.filter(c => c.valuesType === "Hotels").length !== 0) {
                            if (compliancePermissions.allowHolistc) {
                                fetchExtraData('getHolisticData_hotel', {
                                    managementGroup: currentHMG.hmg,
                                    project: currentSol[complianceMainTabActive].sol
                                });
                            } else {
                                console.log("holistic not allowed");
                            }
                        }
                    }

                    let copyOfSelectedExtraProjData = JSON.parse(JSON.stringify(selectedExtraProjData));
                    if (_.isEmpty(copyOfSelectedExtraProjData.appConfigSoftLiveType)) {
                        copyOfSelectedExtraProjData.appConfigSoftLiveType = { [complianceMainTabActive]: appConfigSoftLiveType };
                    } else {
                        copyOfSelectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive] = appConfigSoftLiveType
                    }
                    let modifiedAltSearchIdx = alternateSearchIndexes.map(a => ({
                        "valuesType": a.valuesType,
                        "indexName": a.name
                    }));
                    if (_.isEmpty(copyOfSelectedExtraProjData.altSearchIdx)) {
                        copyOfSelectedExtraProjData.altSearchIdx = { [complianceMainTabActive]: modifiedAltSearchIdx };
                    } else {
                        copyOfSelectedExtraProjData.altSearchIdx[complianceMainTabActive] = modifiedAltSearchIdx
                    }
                    setSelectedExtraProjData(copyOfSelectedExtraProjData);
                    // let copiedCurrentIndexes = { ...currentIndexes };
                    copiedCurrentIndexes[complianceMainTabActive] = temptindexes
                    setCurrentIndexes({ ...copiedCurrentIndexes });

                }

            }
        }
        return;
    }
    const processCurrentIndexes = (indexType, status) => {
        //TODO remove updatedData prop , check updatedData in filterUpdatedData.current exists. if exist set the new update and remove from filterUpdatedData.current
        let copiedCurrentProj = { ...currentProj };
        let copiedCurrentIndex = [...currentIndexes[complianceMainTabActive][indexType]];
        let copiedUpdatedData = {};
        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
            if (filterUpdatedData.current.updatedData[complianceMainTabActive][indexType] !== undefined) {
                copiedUpdatedData = JSON.parse(JSON.stringify(filterUpdatedData.current.updatedData[complianceMainTabActive][indexType]));
            }
        }
        if (status === undefined) {
            delete copiedCurrentProj[indexType][complianceMainTabActive]
        }

        let copiedCurrentIndexProj = { ...copiedCurrentProj[indexType] }
        for (const CIndex of copiedCurrentIndex) {
            let filterTypeTemp = indexesFilterType[currentSol[complianceMainTabActive].sol].find(i => i.indexName === CIndex.name); //filter mode extraction

            if (CIndex.type.toLowerCase() === "date") {
                let filterType = filterTypeTemp !== undefined ? filterTypeTemp.mode : datePickerConfigs.mode.SINGLE;
                let dateConfig = {}
                if (CIndex.indexDepends === null) {

                } else { // if the index depends on a parent index /** NOTE:Multi parent indexes depency data processing not built */
                    let splited = indexType.split("_");
                    let level = splited[0].charAt(1);
                    let newLevel = parseInt(level) - 1;
                    let prevIndexLevel = 'l' + newLevel + '_' + splited[1];
                    if (currentIndexes[complianceMainTabActive][prevIndexLevel] !== undefined && currentIndexes[complianceMainTabActive][prevIndexLevel].length !== 0) {
                        let dependantIndex = currentIndexes[complianceMainTabActive][prevIndexLevel].find(i => i._id === CIndex.indexDepends);
                        if (dependantIndex !== undefined) {
                            let dependentIndexVal = copiedCurrentProj[prevIndexLevel][complianceMainTabActive][dependantIndex.name]["singleData"];
                            if (!_.isEmpty(dependentIndexVal)) {
                                let tempdateConfig = structureIndexData("DependingDate", { "mode": filterType, "dependentIndexValueType": dependantIndex.valuesType, "dependentIndexValue": dependentIndexVal }, [compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")]);
                                dateConfig = { [dependantIndex.name]: tempdateConfig[complianceMainTabActive] }
                            } else {
                                // TODO
                            }
                        }
                    }
                }

                /** --- assign to current index project --- */
                if (copiedCurrentIndexProj[complianceMainTabActive] === undefined) {
                    copiedCurrentIndexProj[complianceMainTabActive] = { [CIndex.name]: { "dateConfig": dateConfig } }
                } else {
                    copiedCurrentIndexProj[complianceMainTabActive][CIndex.name] = { "dateConfig": dateConfig }
                }

            } else if (CIndex.type.toLowerCase() === "text") {
                let filterType = filterTypeTemp !== undefined ? filterTypeTemp.mode : dropDownConfigs.mode.SINGLE;
                let groupingMode = filterTypeTemp !== undefined ? filterTypeTemp.groupingMode : [];
                let singleList = [];
                let groupedList = [];
                let listConfig = {};
                if (CIndex.indexDepends === null) {
                    if (CIndex.valuesType === "Hotels") {
                        if (copiedUpdatedData[CIndex.name] !== undefined) {
                            if (copiedUpdatedData[CIndex.name].singleData !== undefined) {
                                singleList = copiedUpdatedData[CIndex.name].singleData;
                            } else {
                                singleList = copiedCurrentIndexProj[complianceMainTabActive][CIndex.name]['singleData'];
                            }

                        } else {
                            singleList = !_.isEmpty(holisticData) ?
                                currentSol[complianceMainTabActive].projData.hotels.concat(holisticData.data) :
                                currentSol[complianceMainTabActive].projData.hotels.concat([]);
                        }
                        if (singleList.length !== 0) {
                            if (env === envs.MARRIOTT) {
                                singleList = _.sortBy(singleList, (o) => o.code);
                            } else {
                                singleList = _.sortBy(singleList, (o) => o.name);
                            }

                            singleList = structureIndexData("Hotels", singleList, [compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")]);

                            let tempgroupedList = [];
                            if (groupingMode.includes(dropDownConfigs.groupingMode.VIEW)) {
                                if (copiedUpdatedData[CIndex.name] !== undefined) {
                                    if (copiedUpdatedData[CIndex.name].groupedData !== undefined) {
                                        tempgroupedList = copiedUpdatedData[CIndex.name].groupedData;
                                    } else {
                                        tempgroupedList = copiedCurrentIndexProj[complianceMainTabActive][CIndex.name]['groupedData'];
                                    }
                                } else {
                                    tempgroupedList = appConfigData.hotelGroups;
                                }
                            }

                            groupedList = _.sortBy(tempgroupedList, (o) => o.groupName);
                            if (groupedList.length !== 0) {
                                groupedList = structureIndexData("Grouping", { "groupedData": groupedList, "comparingData": singleList, "comparingDataType": CIndex.valuesType, "user": loggedUserData.rawUserName }, [compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")]);
                            }
                        } else {
                            printError({
                                display: true,
                                err: true,
                                errCode: "Error",
                                errType: "messageErr",
                                errMsg: `List of ${CIndex.name} not available`,
                                app: apps.COMPLIANCE
                            });
                        }
                    } else if (CIndex.valuesType === "Report Category") {
                        singleList[complianceMainTabActive] = CIndex.values;
                        singleList[complianceMainTabActive] = _.sortBy(singleList[complianceMainTabActive]);
                    } else {
                        singleList[complianceMainTabActive] = CIndex.values;
                        singleList[complianceMainTabActive] = _.sortBy(singleList[complianceMainTabActive]);
                    }

                    listConfig = { "singleData": singleList[complianceMainTabActive] !== undefined ? singleList[complianceMainTabActive] : [], "groupedData": groupedList[complianceMainTabActive] !== undefined ? groupedList[complianceMainTabActive] : [] }
                } else { // if the index depends on a parent index /** NOTE:Multi parent indexes depency data processing not built */
                    let splited = indexType.split("_");
                    let level = splited[0].charAt(1);
                    let newLevel = parseInt(level) - 1;
                    let prevIndexLevel = 'l' + newLevel + '_' + splited[1];
                    if (currentIndexes[complianceMainTabActive][prevIndexLevel] !== undefined && currentIndexes[complianceMainTabActive][prevIndexLevel].length !== 0) {
                        let dependantIndex = currentIndexes[complianceMainTabActive][prevIndexLevel].find(i => i._id === CIndex.indexDepends);
                        if (dependantIndex !== undefined) {
                            let dependentIndexVal = [];
                            if (dependantIndex.indexDepends === null) { //check dependent index is also a depending index or not
                                dependentIndexVal = copiedCurrentProj[prevIndexLevel][complianceMainTabActive][dependantIndex.name]["singleData"];
                            } else {
                                let splitedDependentIndexLevel = prevIndexLevel.split("_");
                                let dependentIndexLevel = splitedDependentIndexLevel[0].charAt(1);
                                let dependentIndexNewLevel = parseInt(dependentIndexLevel) - 1;
                                let dependentIndexprevIndexLevel = 'l' + dependentIndexNewLevel + '_' + splitedDependentIndexLevel[1];
                                let dependentIndex_indexDepends = currentIndexes[complianceMainTabActive][dependentIndexprevIndexLevel].find(i => i._id === dependantIndex.indexDepends);
                                if (dependentIndex_indexDepends !== undefined) {
                                    dependentIndexVal = copiedCurrentProj[prevIndexLevel][complianceMainTabActive][dependantIndex.name][dependentIndex_indexDepends.name]["singleData"];
                                } else {
                                    //TODO -error-list not available
                                }
                            }
                            if (!_.isEmpty(dependentIndexVal)) {
                                if (CIndex.valuesType === "Report Category") {
                                    singleList = categoryReportData.hotelsReportsMappedCategories;
                                } else if (CIndex.valuesType === "Report") {
                                    singleList = categoryReportData.hotelsCategoriesMappedReports;
                                }
                                singleList = structureIndexData("DependingText", { "mode": filterType, "dependentIndexValueType": dependantIndex.valuesType, "dependentIndexName": dependantIndex.name, "dependentIndexValue": dependentIndexVal, "currentIndxname": CIndex.name, "currentIndxValue": singleList, "currentSolSecTriggerData": currentSolSecTriggerData[complianceMainTabActive] }, [compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")]);

                                listConfig = { [dependantIndex.name]: { "singleData": singleList[complianceMainTabActive] !== undefined ? singleList[complianceMainTabActive] : [], "groupedData": groupedList[complianceMainTabActive] !== undefined ? groupedList[complianceMainTabActive] : [] } }
                            } else {
                                listConfig = { [dependantIndex.name]: { "singleData": [], "groupedData": [] } }
                            }
                        }
                    }

                }
                /** --- assign to current index project --- */
                if (copiedCurrentIndexProj[complianceMainTabActive] === undefined) {
                    copiedCurrentIndexProj[complianceMainTabActive] = { [CIndex.name]: listConfig }
                } else {
                    copiedCurrentIndexProj[complianceMainTabActive][CIndex.name] = listConfig
                }

                /** --- check if next level available and request appropriate data --- */
                if (indexType !== 'independentIndexes') {
                    let splited = indexType.split("_");
                    let level = splited[0].charAt(1);
                    let newLevel = parseInt(level) + 1;
                    let nextIndexLevel = 'l' + newLevel + '_' + splited[1];
                    if (currentIndexes[complianceMainTabActive][nextIndexLevel] !== undefined && currentIndexes[complianceMainTabActive][nextIndexLevel].length !== 0) {
                        let dependingIndexes = currentIndexes[complianceMainTabActive][nextIndexLevel].filter(i => i.indexDepends === CIndex._id);
                        if (dependingIndexes.length !== 0) {
                            for (const dIndx of dependingIndexes) {
                                if (dIndx.valuesType === "Report Category") {
                                    fetchExtraData('getReportCategoryData_hotel', {
                                        userName: loggedUserData.rawUserName,
                                        hotels: (singleList[complianceMainTabActive] || [])
                                    });

                                } else if (dIndx.valuesType === "Report") {
                                    // getReportData_hotel_category
                                    if (CIndex.valuesType === "Report Category") {

                                    } else if (CIndex.valuesType === "Hotels") {
                                        fetchExtraData('getReportCategoryData_hotel', {
                                            userName: loggedUserData.rawUserName,
                                            hotels: (singleList[complianceMainTabActive] || [])
                                        });
                                    }
                                }
                            }
                        }

                    }
                }

            }
        }

        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
            if (filterUpdatedData.current.updatedData[complianceMainTabActive][indexType] !== undefined) {
                let tempfilterUpdatedData = JSON.parse(JSON.stringify(filterUpdatedData.current.updatedData));
                delete tempfilterUpdatedData[complianceMainTabActive][indexType];
                filterUpdatedData.current.updatedData = tempfilterUpdatedData;
            }
        }
        setCurrentProj({ ...currentProj, [indexType]: copiedCurrentIndexProj });
        return;
    }
    const handleIndexProjData = (indexType, key, selectedOption, valuesType, type) => {
        //TODO 
        // check changedData in filterUpdatedData.current exists. if exist compair the selectedOption with changedData, if same, 
        // set compSearchData.current.isNewRequest = true; compSearchData.current.paginationReset = true; compSearchData.current.isInitialReq = false;
        let selectedItems = {};
        let errClosure = false; // total process declinable err
        let ejectableIndexes = [] // not total process declinable error but need to eject from filter list due to some error and proceed with remaining
        let onChangeCurrentIndex = false;
        let currentProjIndexes = {};
        let copiedChangedData = {};
        let tempFilter = [];

        let filterObjArr = [...filterObjs];
        let tempcopiedIndexSelectedProjData;
        let tempcopiedSelectedProjData;
        if (filterUpdatedData.current.selectedProjDataChanged.isChanged === true) {
            tempcopiedSelectedProjData = JSON.parse(JSON.stringify(filterUpdatedData.current.selectedProjDataChanged.changedData));
            tempcopiedIndexSelectedProjData = JSON.parse(JSON.stringify(filterUpdatedData.current.selectedProjDataChanged.changedData[indexType]));
        } else {
            tempcopiedSelectedProjData = JSON.parse(JSON.stringify(selectedProjData))
            tempcopiedIndexSelectedProjData = JSON.parse(JSON.stringify(selectedProjData[indexType]));
        }
        if (key !== undefined && selectedOption !== undefined && !_.isEmpty(selectedOption)) { //if onchange happens TODO
            selectedItems = { ...tempcopiedIndexSelectedProjData[complianceMainTabActive] };
            currentProjIndexes[key] = { ...currentProj[indexType][complianceMainTabActive][key] };
            onChangeCurrentIndex = true;
        } else {
            currentProjIndexes = { ...currentProj[indexType][complianceMainTabActive] }
        }

        if (!_.isEmpty(filterUpdatedData.current.changedData) && filterUpdatedData.current.changedData[complianceMainTabActive] !== undefined) {
            if (filterUpdatedData.current.changedData[complianceMainTabActive][indexType] !== undefined) {
                copiedChangedData = JSON.parse(JSON.stringify(filterUpdatedData.current.changedData[complianceMainTabActive][indexType]));
            }
        }

        for (const indx in currentProjIndexes) {
            let err = false; // total process undeclinable err
            let indexDef = currentIndexes[complianceMainTabActive][indexType].find(i => i.name === indx);
            let filterTypeTemp = indexesFilterType[currentSol[complianceMainTabActive].sol].find(i => i.indexName === indexDef.name); //filter mode extraction
            let currentIndexParents = getIterativeDependencies(indx, "parent", indexesMapping[currentSol[complianceMainTabActive].sol], "indexName").filter(idx => {
                return Object.keys(currentIndexes[complianceMainTabActive]).find((key) => {
                    return _.findIndex(currentIndexes[complianceMainTabActive][key], i => i.name === idx) > -1
                }) !== undefined
            });
            switch (indexDef.valuesType) {
                case 'Hotels':
                    compSearchData.current.hotelIdx = indexDef.name
                    break;
                case 'Date':
                    compSearchData.current.bDateIdx = indexDef.name
                    break;
                case 'Report Category':
                    compSearchData.current.reportCatIdx = indexDef.name
                    break;
                case 'Report':
                    compSearchData.current.reportIdx = indexDef.name
                    break;
                default:
                    break;
            }
            if (indexDef.type.toLowerCase() === "date") {
                let mode = filterTypeTemp !== undefined ? filterTypeTemp.mode : datePickerConfigs.mode.SINGLE
                let pickerType = datePickerConfigs.pickerType.DATE;
                let dFormat = indexDef.format === "MM-dd-yyyy" ? "MM-DD-YYYY" : indexDef.format;
                let selectedRange = mode === datePickerConfigs.mode.RANGE ?
                    (indexDef.name === "Date" ?
                        [moment().subtract(1, "days").format(dFormat), moment().subtract(1, "days").format(dFormat)] :
                        [moment().format(dFormat), moment().format(dFormat)]) :
                    (indexDef.name === "Date" ? [moment().subtract(1, "days").format(dFormat)] : [moment().format(dFormat)]);
                let disabledRange = { type: datePickerConfigs.disableRangeType.MIN_MAX, val: indexDef.name === "Date" ? [moment().subtract(1, "days").format(dFormat)] : [moment().format(dFormat)] };
                let modeExtensions = [];
                let schedules = [];

                if (indexType !== 'l1_Indexes' || indexType !== 'independentIndexes') {
                    let splited = indexType.split("_");
                    let level = splited[0].charAt(1);
                    let newLevel = parseInt(level) - 1;
                    let prevIndexType = 'l' + newLevel + '_' + splited[1];
                    if (!_.isEmpty(currentProj[indexType][complianceMainTabActive][indx].dateConfig)) {
                        let dependentIndxValTypes = Object.keys(currentProj[indexType][complianceMainTabActive][indx].dateConfig);
                        for (const dependentIndxValType of dependentIndxValTypes) { //normally no multiple dependents for single depending
                            let selectedDependent = Object.fromEntries(Object.entries(tempcopiedSelectedProjData[prevIndexType][complianceMainTabActive]).filter(([k, v]) => k === dependentIndxValType));
                            //check array(dependent multiselect) or string (dependent single select)
                            if (!_.isEmpty(selectedDependent)) {
                                let selectedConfigs = [];
                                let startingDates = [];
                                let allowedRange = []
                                let selectedDependentValue = selectedDependent[dependentIndxValType];
                                if (Array.isArray(selectedDependentValue)) { // dependent index is multiselect
                                    if (selectedDependentValue.length !== 0) {
                                        if (dependentIndxValType === "Hotels") {
                                            selectedConfigs = currentProj[indexType][complianceMainTabActive][indx].dateConfig[dependentIndxValType]
                                                .filter(i => selectedDependentValue
                                                    .find(s => {
                                                        let tempJ = JSON.parse(s);
                                                        if (tempJ.userGroupId === undefined) { // if selected is a hotel
                                                            return tempJ.codeEnv === i.codeEnv
                                                        } else { // if selected is a group
                                                            return tempJ.mappedList.find(m => m.env === i.env && m.id === i.id) !== undefined // TODO : +disabled check
                                                        }
                                                    })
                                                )
                                        }
                                        schedules = getUnique(_.flatten(selectedConfigs.filter(f => f.schedule.length !== 0).map(m => m.schedule)), '', '');
                                        if (indexDef.name !== "Date") {
                                            startingDates = getUnique(selectedConfigs.filter(f => f.startDate !== "").map(m => m.startDate), 'date', dFormat)
                                                .sort((a, b) => moment(a, dFormat).diff(moment(b, dFormat)));
                                            allowedRange = startingDates.length === 0 ? [moment().format(dFormat)] : [startingDates[0], moment().format(dFormat)] // if starting.length === 0 current only
                                        }
                                    }
                                } else { // dependent index is single select
                                    if (selectedDependentValue !== "" || selectedDependentValue !== null) {
                                        if (dependentIndxValType === "Hotels") {
                                            selectedConfigs = currentProj[indexType][complianceMainTabActive][indx].dateConfig[dependentIndxValType]
                                                .filter(i => selectedDependentValue === i.codeEnv)
                                        }
                                        schedules = getUnique(_.flatten(selectedConfigs.filter(f => f.schedule.length !== 0).map(m => m.schedule)), '', '');
                                        if (indexDef.name !== "Date") {
                                            startingDates = getUnique(selectedConfigs.filter(f => f.startDate !== "").map(m => m.startDate), 'date', dFormat)
                                                .sort((a, b) => moment(a, dFormat).diff(moment(b, dFormat)));
                                            allowedRange = startingDates.length === 0 ? [moment().format(dFormat)] : [startingDates[0], moment().format(dFormat)] // if starting.length === 0 current only
                                        }
                                    }
                                }

                                selectedRange = processDateConfigs('selectedRange', complianceMainTabActive, indexDef.valuesType, schedules, mode, dFormat);
                                if (allowedRange.length !== 0) {
                                    disabledRange = processDateConfigs('disableRange', complianceMainTabActive, indexDef.valuesType, schedules, mode, dFormat, allowedRange);
                                } else {
                                    disabledRange = {
                                        type: (complianceMainTabActive !== customTabView.DEFAULT.KEY ? datePickerConfigs.disableRangeType.CONFIG : datePickerConfigs.disableRangeType.MIN_MAX),
                                        val: complianceMainTabActive !== customTabView.DEFAULT.KEY ?
                                            ({
                                                scheduleType: complianceMainTabActive,
                                                sceduleConf: schedules,
                                                max: (indexDef.name === "Date" ? [moment().subtract(1, "days").format(dFormat)] : [moment().format(dFormat)])
                                            }) :
                                            (indexDef.name === "Date" ? [moment().subtract(1, "days").format(dFormat)] : [moment().format(dFormat)])
                                    }
                                }
                                modeExtensions = processDateConfigs('modeExtensions', complianceMainTabActive, indexDef.valuesType, schedules, mode, dFormat);

                            } else { // No matching dependent index for the depending index
                                errClosure = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: "No matching dependent index for the depending index",
                                    app: apps.COMPLIANCE
                                });
                            }


                        }
                    }
                }

                if (!errClosure) {
                    let tempSelection = [];
                    if (onChangeCurrentIndex) {
                        tempSelection = selectedOption;
                    }
                    // else if(!onChangeCurrentIndex && isFilterOnChange.current) { //filter onChange occured but not the current index
                    //     //if onChanged index is a parent of current index - reset the selection else keep the previous selections
                    //     tempSelection = currentIndexParents.find(cip=> cip === triggeredFilterData.key) !== undefined ? [] : tempSelection.concat(tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx]);
                    // }
                    else if (indx === 'Date' && props.compSearchParams !== null &&
                        (props.compSearchParams.triggerSchedule !== undefined && props.compSearchParams.triggerSchedule === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")) &&
                        (props.compSearchParams.sDate !== undefined && props.compSearchParams.sDate !== "") &&
                        (props.compSearchParams.eDate !== undefined && props.compSearchParams.eDate !== "")) { // use URL param to set sDate and eDate
                        tempSelection = [props.compSearchParams.sDate, props.compSearchParams.eDate];
                    } else if (tempcopiedSelectedProjData[indexType][complianceMainTabActive] !== undefined &&
                        tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx] !== undefined &&
                        !_.isEmpty(tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx])) { //if already set use it (if tab change)
                        tempSelection = tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx];
                        // selectedItems[indx] = selectedProjData[indexType][complianceMainTabActive][indx];
                    } else {
                        tempSelection = selectedRange
                    }

                    if (mode === datePickerConfigs.mode.RANGE) { // rangepicker
                        let selected = [];
                        if (disabledRange.type === datePickerConfigs.disableRangeType.MIN_MAX) {
                            for (const selectediterator of tempSelection) {
                                if (disabledRange.val.length > 1) {
                                    if ((moment(selectediterator, dFormat).isSame(moment(disabledRange.val[0], dFormat)) || moment(selectediterator, dFormat).isAfter(moment(disabledRange.val[0], dFormat))) &&
                                        (moment(selectediterator, dFormat).isSame(moment(disabledRange.val[1], dFormat)) || moment(selectediterator, dFormat).isBefore(moment(disabledRange.val[1], dFormat)))) {
                                        selected = selected.concat(selectediterator);
                                    }
                                } else {
                                    if ((moment(selectediterator, dFormat).isSame(moment(disabledRange.val[0], dFormat)) || moment(selectediterator, dFormat).isBefore(moment(disabledRange.val[0], dFormat)))) {
                                        selected = selected.concat(selectediterator);
                                    }
                                }
                            }
                            if (selected.length > 1) {
                                selectedItems[indx] = tempSelection;
                            } else {
                                selectedItems[indx] = selectedRange;
                            }

                        } else if (disabledRange.type === datePickerConfigs.disableRangeType.ADHOC) {
                            let included = [];
                            for (const enabledDate of disabledRange.val) {
                                if ((moment(enabledDate, dFormat).isSame(moment(tempSelection[0], dFormat)) || moment(enabledDate, dFormat).isAfter(moment(tempSelection[0], dFormat))) &&
                                    (moment(enabledDate, dFormat).isSame(moment(tempSelection[1], dFormat)) || moment(enabledDate, dFormat).isBefore(moment(tempSelection[1], dFormat)))) {
                                    included.push(true);
                                } else {
                                    included.push(false);
                                }
                            }
                            if (included.find(f => f === true) !== undefined) {
                                selectedItems[indx] = tempSelection;
                            } else {
                                selectedItems[indx] = selectedRange;
                            }
                        } else if (disabledRange.type === datePickerConfigs.disableRangeType.CONFIG) {
                            let enabledDates = processDateConfigs('disableRange', complianceMainTabActive, indexDef.valuesType, schedules, mode, dFormat, tempSelection);
                            if (((moment(tempSelection[0], dFormat).isSame(moment(disabledRange.val.max[0], dFormat)) || moment(tempSelection[0], dFormat).isBefore(moment(disabledRange.val.max[0], dFormat))) &&
                                (moment(tempSelection[1], dFormat).isSame(moment(disabledRange.val.max[0], dFormat)) || moment(tempSelection[1], dFormat).isBefore(moment(disabledRange.val.max[0], dFormat)))) &&
                                (!_.isEmpty(enabledDates) && (enabledDates.val !== undefined && !_.isEmpty(enabledDates.val)))
                            ) {
                                let selected = [];
                                for (const ed of enabledDates.val) {
                                    if (
                                        (moment(ed, dFormat).isSame(moment(tempSelection[0], dFormat)) || moment(ed, dFormat).isAfter(moment(tempSelection[0], dFormat))) &&
                                        (moment(ed, dFormat).isSame(moment(tempSelection[1], dFormat)) || moment(ed, dFormat).isBefore(moment(tempSelection[1], dFormat)))
                                    ) {
                                        selected = selected.concat(ed);
                                    }
                                }
                                if (selected.length > 0) {
                                    selectedItems[indx] = tempSelection;
                                } else {
                                    selectedItems[indx] = selectedRange;
                                }

                            } else {
                                selectedItems[indx] = selectedRange;
                            }
                        }
                    } else { // single picker
                        if (disabledRange.type === datePickerConfigs.disableRangeType.MIN_MAX) {
                            if (disabledRange.val.length > 1) {
                                if ((moment(tempSelection[0], dFormat).isSame(moment(disabledRange.val[0], dFormat)) || moment(tempSelection[0], dFormat).isAfter(moment(disabledRange.val[0], dFormat))) &&
                                    (moment(tempSelection[0], dFormat).isSame(moment(disabledRange.val[1], dFormat)) || moment(tempSelection[0], dFormat).isBefore(moment(disabledRange.val[1], dFormat)))) {
                                    selectedItems[indx] = tempSelection;
                                } else {
                                    selectedItems[indx] = selectedRange;
                                }
                            } else {
                                if ((moment(tempSelection[0], dFormat).isSame(moment(disabledRange.val[0], dFormat)) || moment(tempSelection[0], dFormat).isBefore(moment(disabledRange.val[0], dFormat)))) {
                                    selectedItems[indx] = tempSelection;
                                } else {
                                    selectedItems[indx] = selectedRange;
                                }
                            }

                        } else if (disabledRange.type === datePickerConfigs.disableRangeType.ADHOC) {
                            let included = [];
                            for (const enabledDate of disabledRange.val) {
                                if (moment(enabledDate, dFormat).isSame(moment(tempSelection[0], dFormat))) {
                                    included.push(true);
                                } else {
                                    included.push(false);
                                }
                            }
                            if (included.find(f => f === true) !== undefined) {
                                selectedItems[indx] = tempSelection;
                            } else {
                                selectedItems[indx] = selectedRange;
                            }
                        } else if (disabledRange.type === datePickerConfigs.disableRangeType.CONFIG) {
                            if (moment(tempSelection[0], dFormat).isSame(moment(disabledRange.val.max[0], dFormat)) || moment(tempSelection[0], dFormat).isBefore(moment(disabledRange.val.max[0], dFormat))) {
                                selectedItems[indx] = tempSelection;
                            } else {
                                selectedItems[indx] = selectedRange;
                            }

                        }
                    }

                    compSearchData.current.searchData[indx] = { searchVal: selectedItems[indx], valuesType: indexDef.valuesType, additionalData: compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE") === 'Daily' ? 'range' : 'adhoc' }

                    let datepickerIndx = {
                        name: indexDef.name,
                        order: indexDef.order,
                        type: indexDef.type.toLowerCase(),
                        valuesType: indexDef.valuesType,
                        indexCategory: indexType,
                        selectedRange: selectedItems[indx],
                        disallowRange: disabledRange,
                        mode: mode,
                        modeExtensions: modeExtensions,
                        pickerType: pickerType, // conditions might need later
                        format: dFormat,
                        apply: (modeExtensions.length !== 0 && !(modeExtensions.length < 2 && modeExtensions.includes(datePickerConfigs.modeExtension.CUSTOM_RANGE))) ? datePickerConfigs.apply.ONAPPLY : datePickerConfigs.apply.ONCHANGE, //modeExtensions contains customrange - apply
                        onChangeFn: setTriggeredFilterData
                    }

                    let datePickerobj = CreateDatePicker(datepickerIndx);
                    tempFilter.push(datePickerobj);
                }



            } else if (indexDef.type.toLowerCase() === "text") {
                let fieldList = [];
                let isGroupingData = false;
                let groupingMode = filterTypeTemp !== undefined ? filterTypeTemp.groupingMode : [];
                let multiSelect = filterTypeTemp !== undefined ? (filterTypeTemp.mode === dropDownConfigs.mode.MULTIPLE ? true : false) : false;

                /** field List */
                if (indexType === 'l1_Indexes' || indexType === 'independentIndexes') {
                    if (multiSelect) { // if multiselect
                        if (_.isEmpty(currentProj[indexType][complianceMainTabActive][indx]["groupedData"])
                            || currentProj[indexType][complianceMainTabActive][indx]["groupedData"].filter(f => f.isDisable === false).length === 0) { // if grouping not available
                            if (currentProj[indexType][complianceMainTabActive][indx]["singleData"].length !== 0) {
                                fieldList = currentProj[indexType][complianceMainTabActive][indx]["singleData"].map(t => {
                                    return ({
                                        title: t.label,
                                        value: JSON.stringify(t),
                                    })
                                })
                            } else {
                                errClosure = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: `List of ${indexDef.name} not available`,
                                    app: apps.COMPLIANCE
                                });
                                break;
                            }
                        } else { //if grouping available TODO: check again for correction
                            if (currentProj[indexType][complianceMainTabActive][indx]["singleData"].length !== 0) {
                                isGroupingData = true;
                                let treeGroupedData = currentProj[indexType][complianceMainTabActive][indx]["groupedData"].filter(f => f.isDisable === false).map(t => {
                                    return ({
                                        title: t.groupName,
                                        value: JSON.stringify(t),
                                        key: JSON.stringify(t),
                                    })
                                });
                                let treeGroupedDataVal = currentProj[indexType][complianceMainTabActive][indx]["groupedData"].filter(f => f.isDisable === false).map(t => {
                                    return (JSON.stringify(t))
                                });

                                let treesingledata = currentProj[indexType][complianceMainTabActive][indx]["singleData"].map(t => {
                                    return ({
                                        title: t.label,
                                        value: JSON.stringify(t),
                                        key: JSON.stringify(t),
                                    })
                                });
                                let treesingledataVal = currentProj[indexType][complianceMainTabActive][indx]["singleData"].map(t => {
                                    return (JSON.stringify(t))
                                });

                                fieldList = [
                                    {
                                        title: indexDef.name + ' Groups',
                                        className: 'mainTreeNode ' + indexDef.name.toLowerCase() + '_grouping',
                                        value: JSON.stringify(treeGroupedDataVal),//indexDef.name.toLowerCase() + '_grouping',
                                        key: JSON.stringify(treeGroupedDataVal),//indexDef.name.toLowerCase() + '_grouping',
                                        // value: JSON.stringify(treeGroupedData),//indexDef.name.toLowerCase() + '_grouping',
                                        children: treeGroupedData
                                    },
                                    {
                                        title: indexDef.name,
                                        className: 'mainTreeNode ' + indexDef.name.toLowerCase(),
                                        value: JSON.stringify(treesingledataVal),//indexDef.name.toLowerCase(),
                                        key: JSON.stringify(treesingledataVal),//indexDef.name.toLowerCase(),
                                        // value:  JSON.stringify(treesingledata),//indexDef.name.toLowerCase(),
                                        children: treesingledata
                                    }
                                ]
                            } else {
                                errClosure = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: `List of ${indexDef.name} not available`,
                                    app: apps.COMPLIANCE
                                });
                                break;
                            }
                        }
                    } else { // if not multiselect
                        //key value method
                        if (currentProj[indexType][complianceMainTabActive][indx]["singleData"].length !== 0) {
                            fieldList = currentProj[indexType][complianceMainTabActive][indx]["singleData"].map(t => {
                                return ({
                                    key: t.value,
                                    value: t.value,
                                    data: JSON.stringify(t)
                                })
                            })
                        } else {
                            errClosure = true;
                            printError({
                                display: true,
                                err: true,
                                errCode: "Error",
                                errType: "messageErr",
                                errMsg: `List of ${indexDef.name} not available`,
                                app: apps.COMPLIANCE
                            });
                            break;
                        }
                    }
                } else { // neither l1_Indexes nor independentIndexes
                    if (!_.isEmpty(currentProj[indexType][complianceMainTabActive][indx])) {
                        let immediateParents = Object.keys(currentProj[indexType][complianceMainTabActive][indx]);
                        for (const immediateParent of immediateParents) { //normally no same level multi dependents - but have nested
                            let tempFieldList = [];
                            if (multiSelect) { //current index is multiselect
                                if (currentProj[indexType][complianceMainTabActive][indx][immediateParent]["groupedData"].filter(f => f.isDisable === false).length === 0) { // if current index grouping not available
                                    if (!_.isEmpty(currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"])) {
                                        tempFieldList = currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"]
                                    } else {
                                        err = true;
                                        break;
                                    }
                                } else { // if current index grouping available
                                    isGroupingData = true;
                                    if(!_.isEmpty(currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"])){
                                        tempFieldList = currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"]
                                    } else {
                                        err = true;
                                        break;
                                    }
                                    
                                }
                            } else { //current index is single select
                                if(!_.isEmpty(currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"])){
                                    tempFieldList = currentProj[indexType][complianceMainTabActive][indx][immediateParent]["singleData"]
                                } else {
                                    err = true;
                                    break;
                                }
                            }
                            let selectedParentsData = Object.fromEntries(Object.entries(tempcopiedSelectedProjData)
                            .filter(([key, value]) => value[complianceMainTabActive] && !_.isEmpty(value[complianceMainTabActive]))
                            .flatMap(([key, value]) => {
                              return Object.entries(value[complianceMainTabActive])
                                .filter(([inkey]) => currentIndexParents.includes(inkey) && !_.isEmpty(value[complianceMainTabActive][inkey]))
                                // .map(([inkey, data]) => ({ [inkey]: data }));
                            }));
                            if (!_.isEmpty(selectedParentsData)) { //if parent index data available
                                for (const [pk,pv] of Object.entries(selectedParentsData)) {
                                    let selectedParentFilteredFieldList = [];
                                    for (const option of tempFieldList) {//current index fieldlist iteration
                                        if (Array.isArray(pv)) { // parent index is multiselect  
                                                for (const parentSelOpt of pv) { //parent index selected iteration
                                                    let tempJ = JSON.parse(parentSelOpt)
                                                    if (tempJ.userGroupId === undefined) { //selected dependent index data are not grouped
                                                        if (pk === "Hotels") {
                                                            let hotelSecTrigVal = []; //Hotel's Secondary Trigger Vals
                                                            if(complianceMainTabActive !== customTabView.DEFAULT.KEY){ //not daily view
                                                                hotelSecTrigVal = tempJ.customViewTypes.filter(c=> 
                                                                    c.envlopeTriggerIndex === indx && c.envlopeTriggerScheduleType === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")
                                                                ).flatMap(cetv => cetv.envlopeTriggerIndexValue);
                                                            }
                                                            if (hotelSecTrigVal.length !== 0 ){ //envlopeTriggerIndex match with current index else become zero
                                                                if (hotelSecTrigVal.includes(option.value) && 
                                                                    option.mappedList.find(m => 
                                                                        m[pk].findIndex(mv => mv.mappedVal === tempJ.codeEnv) > -1 &&
                                                                        !(tempJ.status.toLowerCase().replace(/\s/g, "") === hotelStatusTypes.SLIVE && 
                                                                        softLiveTypes.DEFAULT === (compliancePermissions.softLiveType || selectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive])
                                                                        ) //exclude hotels that softlive and user permission/app permission given default
                                                                    ) !== undefined) {
                                                                    selectedParentFilteredFieldList.push(option);
                                                                    break;
                                                                }
                                                            } else {
                                                                if (option.mappedList.find(m => m[pk].findIndex(mv => mv.mappedVal === tempJ.codeEnv) > -1 &&
                                                                    !(tempJ.status.toLowerCase().replace(/\s/g, "") === hotelStatusTypes.SLIVE && 
                                                                    softLiveTypes.DEFAULT === (compliancePermissions.softLiveType || selectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive])
                                                                    ) //exclude hotels that softlive and user permission/app permission given default
                                                                ) !== undefined) {
                                                                    selectedParentFilteredFieldList.push(option);
                                                                    break;
                                                                }
                                                            } 
                                                        } else {
                                                            if (option.mappedList.find(m =>
                                                                m[pk].findIndex(mv =>
                                                                    tempJ.additionalData.visibleVal.includes(mv.mappedVal)
                                                                ) > -1) !== undefined) {
                                                                    selectedParentFilteredFieldList.push(option);
                                                                break;
                                                            }
                                                        }
                                                    } else { // selected dependent index data are grouped
                                                        // console.log("tempJ", tempJ);
                                                        if (pk === "Hotels") {
                                                            let copyOfCurProjData = { ...currentProj };
                                                            let currHotelData = Object.entries(copyOfCurProjData)
                                                            .filter(([key, value]) => value[complianceMainTabActive] && !_.isEmpty(value[complianceMainTabActive]))
                                                            .flatMap(([key, value]) => {
                                                                return Object.entries(value[complianceMainTabActive])
                                                                .filter(([inkey]) => inkey === pk)
                                                                .map(([inkey, data]) => (data.singleData));
                                                            }).flat();
                                                            let hotelSecTrigVal = []; //Hotel's Secondary Trigger Vals
                                                            let currHotelDataMappedToGrp = currHotelData.filter(c=> {
                                                                return (
                                                                   tempJ.mappedList.find(m => {
                                                                     return (!m.isDisable && m.id === c.id && m.env === c.env)
                                                                   }) !== undefined &&
                                                                   !(c.status.toLowerCase().replace(/\s/g, "") === hotelStatusTypes.SLIVE && 
                                                                    softLiveTypes.DEFAULT === (compliancePermissions.softLiveType || selectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive])
                                                                    ) //exclude hotels that softlive and user permission/app permission given default
                                                                 )
                                                           })
                                                            if(complianceMainTabActive !== customTabView.DEFAULT.KEY){ //not daily view
                                                                // console.log(currHotelData,"hotelData");
                                                                // console.log(currHotelDataMappedToGrp,"currHotelDataMappedToGrp");
                                                                for (const htl of currHotelDataMappedToGrp) {
                                                                    hotelSecTrigVal = htl.customViewTypes.filter(c=> 
                                                                        c.envlopeTriggerIndex === indx && c.envlopeTriggerScheduleType === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")
                                                                    ).flatMap(cetv => cetv.envlopeTriggerIndexValue);
                                                                }
                                                                
                                                            } 
                                                            if (hotelSecTrigVal.length !== 0 ){
                                                                if (hotelSecTrigVal.includes(option.value)) {
                                                                    selectedParentFilteredFieldList.push(option);
                                                                    break;
                                                                }
                                                            } else {
                                                                let res = option.mappedList.find(m => currHotelDataMappedToGrp.find(t => { 
                                                                    return (m[pk].findIndex(mv => mv.mappedEnv === t.env) > -1 && m[pk].findIndex(mv => mv.mappedId === t.id) > -1)
                                                                }) !== undefined)
                                                                if (res !== undefined) {
                                                                    selectedParentFilteredFieldList.push(option);
                                                                    break;
                                                                }
                                                            }
                                                        } else {
                                                            let res = option.mappedList.find(m => tempJ.mappedList.find(t => { 
                                                                return (!t.isDisable && m[pk].findIndex(mv => mv.mappedEnv === t.env) > -1 && m[pk].findIndex(mv => mv.mappedId === t.id) > -1)
                                                            }) !== undefined)
                                                            if (res !== undefined) {
                                                                selectedParentFilteredFieldList.push(option);
                                                                break;
                                                            }
                                                        }
                                                        
                                                    }
                                                }
                                        } else { // parent index is single select
                                            if (option.mappedList.find(m => m[pk].findIndex(mv => mv.mappedVal === pv) > -1) !== undefined) {
                                                selectedParentFilteredFieldList.push(option);
                                                break;
                                            }     
                                        }
                                    }
                                    tempFieldList = selectedParentFilteredFieldList;
                                }
                                
                                if (tempFieldList.length === 0) {
                                    err = true;
                                    // printError({
                                    //     display: true,
                                    //     err: true,
                                    //     errCode: "Error",
                                    //     errType: "messageErr",
                                    //     errMsg: `List of ${indexDef.name} not matching for the selected ${dependentIndxValType}`,
                                    //     app: apps.COMPLIANCE
                                    // });
                                    // break;
                                } else {
                                    if (multiSelect) { 
                                        fieldList = tempFieldList.map(m => {
                                            return ({
                                                title: m.label,
                                                value: JSON.stringify(m),
                                            })
                                        });
                                    } else {
                                        let copyOftempFieldList = JSON.parse(JSON.stringify(tempFieldList));
                                                    let allValIndex = _.findIndex(copyOftempFieldList, function (o) { return o.value === "All" });
                                                    let allVal = [];
                                                    if (allValIndex !== -1) { // if All option available
                                                        allVal = copyOftempFieldList.splice(allValIndex, 1);
                                                    }
                                                    if (allVal.length !== 0 && copyOftempFieldList.length <= 1) { // if All option available and if the option list less that or equal to 1 remove All option from list
                                                        fieldList = copyOftempFieldList.map(m => {
                                                            return ({
                                                                key: m.value,
                                                                value: m.value,
                                                                data: JSON.stringify(m)
                                                            })
                                                        })
                                                    } else {
                                                        fieldList = tempFieldList.map(m => {
                                                            return ({
                                                                key: m.value,
                                                                value: m.value,
                                                                data: JSON.stringify(m)
                                                            })
                                                        })
                                                    }
                                    }
                                }
                            } else { //if parent index data not available
                                errClosure = true;
                                printError({
                                    display: true,
                                    err: true,
                                    errCode: "Error",
                                    errType: "messageErr",
                                    errMsg: `No selected in parent indexes ${currentIndexParents.toString()} for ${indexDef.name} `,
                                    app: apps.COMPLIANCE
                                });
                                break;
                            }
                        }
                    } else {
                        err = true;
                    } // TODO : handle error : eg if values type none for this index =>becomes empty, if no reports and no categories(parent) => becomes empty
                }

                if (!errClosure && !err) {
                    let tempSelection = [];
                    if (onChangeCurrentIndex) { //current index onchange
                        tempSelection = tempSelection.concat(selectedOption);
                    } else if (!onChangeCurrentIndex && isFilterOnChange.current) { //filter onChange occured but not the current index
                        //if onChanged index is a parent of current index - reset the selection else keep the previous selections
                        tempSelection = currentIndexParents.find(cip => cip === triggeredFilterData.key) !== undefined ? [] : tempSelection.concat(tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx]);
                    } else if (indx === "Hotels" && props.compSearchParams !== null && (props.compSearchParams.triggerSchedule !== undefined &&
                        props.compSearchParams.triggerSchedule === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")) &&
                        (props.compSearchParams.hName !== undefined && props.compSearchParams.hName !== "")) { // use URL param to set hName
                        tempSelection = tempSelection.concat(props.compSearchParams.hName);
                    } else if (props.compSearchParams !== null && (props.compSearchParams.triggerSchedule !== undefined &&
                        props.compSearchParams.triggerSchedule === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE")) &&
                        (props.compSearchParams.triggerIndex !== undefined && props.compSearchParams.triggerIndex !== "" &&
                            currentSolSecTriggerData[complianceMainTabActive].find(c => c.envlopeTriggerScheduleType === props.compSearchParams.triggerSchedule && c.envlopeTriggerIndex === props.compSearchParams.triggerIndex) !== undefined) &&
                        ((props.compSearchParams.triggerIndexVal !== undefined && props.compSearchParams.triggerIndexVal !== ""))) { // use URL param to set triggerindex with its triggerindex value
                        tempSelection = props.compSearchParams.triggerIndexVal.split(",");
                    } else if (tempcopiedSelectedProjData[indexType][complianceMainTabActive] !== undefined && tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx] !== undefined && !_.isEmpty(selectedProjData[indexType][complianceMainTabActive][indx])) { //if already set use it (if tab change)
                        tempSelection = tempSelection.concat(tempcopiedSelectedProjData[indexType][complianceMainTabActive][indx]);
                    }
                    if (multiSelect) { // if multi select
                        let selected = [];
                        let selectedGroupedToSingle = [];
                        for (const selIterator of tempSelection) {
                            if (JSON.parse(selIterator).userGroupId === undefined) { //selector is from single data
                                let tempJ = [];
                                if (isGroupingData) { // if grouped
                                    tempJ = _.flatten(fieldList.filter(f => f.className.split("_").slice(-1)[0] !== "grouping").map(m => JSON.parse(m.value)));
                                } else {
                                    tempJ = fieldList.map(f => f.value);
                                }
                                let tempSelected = [];
                                if (indexDef.valuesType === "Hotels") {
                                    tempSelected = tempJ.filter(f => {
                                        let tempJ2 = JSON.parse(f);
                                        return (tempJ2.codeEnv === JSON.parse(selIterator).codeEnv);
                                    });
                                } else {
                                    tempSelected = tempJ.filter(f => {
                                        let tempJ2 = JSON.parse(f);
                                        return (tempJ2.value === JSON.parse(selIterator).value);
                                    });
                                }

                                selected = selected.concat(tempSelected)
                            } else { //selector is from group data
                                if (isGroupingData) { // if grouped
                                    let tempJ = _.flatten(fieldList.filter(f => f.className.split("_").slice(-1)[0] === "grouping").map(m => JSON.parse(m.value)));
                                    let tempSelected = tempJ.filter(f => {
                                        let tempJ2 = JSON.parse(f);
                                        return (tempJ2.userGroupId === JSON.parse(selIterator).userGroupId && tempJ2.groupId === JSON.parse(selIterator).groupId)
                                    });
                                    selected = selected.concat(tempSelected);

                                    if (tempSelected.length !== 0) {
                                        let tempselectedGroupedToSingle = _.uniq(_.flatten(tempSelected.map(t => JSON.parse(t).mappedList)), (n) => (n.id && n.env));
                                        let hotelList = _.flatten(fieldList.filter(f => f.className.split("_").slice(-1)[0] !== "grouping").map(m => JSON.parse(m.value)));
                                        for (const iterator of tempselectedGroupedToSingle) {
                                            let temph = hotelList.filter(f => {
                                                let tempJ3 = JSON.parse(f);
                                                return (tempJ3.id === iterator.id && tempJ3.env === iterator.env)
                                            });
                                            selectedGroupedToSingle = selectedGroupedToSingle.concat(temph)
                                        }
                                    }
                                }
                            }

                        }
                        if (selected.length !== 0) {
                            selectedItems[indx] = selected;
                            if (selectedGroupedToSingle.length !== 0) {
                                selectedGroupedToSingle = _.uniq(selectedGroupedToSingle, (n) => {
                                    return JSON.parse(n).codeEnv !== undefined ? JSON.parse(n).codeEnv : JSON.parse(n).value
                                });
                                if (indexDef.valuesType === "Hotels") {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: selectedGroupedToSingle.map(s => JSON.parse(s)),
                                        valuesType: indexDef.valuesType,
                                        additionalData: ""
                                    }
                                } else {
                                    let filterExcludedSelectedGroupedToSingle = selectedGroupedToSingle.filter(s => JSON.parse(s).additionalData.type === "exclude");

                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (filterExcludedSelectedGroupedToSingle.length === 0) ?
                                            selectedGroupedToSingle.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]) :
                                            filterExcludedSelectedGroupedToSingle.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]),
                                        valuesType: indexDef.valuesType,
                                        additionalData: (filterExcludedSelectedGroupedToSingle.length === 0) ? JSON.parse(selectedGroupedToSingle[0]).additionalData.type : "exclude"
                                    }
                                }
                            } else {
                                if (indexDef.valuesType === "Hotels") {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: selected.map(s => JSON.parse(s)),
                                        valuesType: indexDef.valuesType,
                                        additionalData: ""
                                    }
                                } else {
                                    let filterExcludedSelected = selected.filter(s => JSON.parse(s).additionalData.type === "exclude");

                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (filterExcludedSelected.length === 0) ?
                                            selected.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]) :
                                            filterExcludedSelected.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]),
                                        valuesType: indexDef.valuesType,
                                        additionalData: (filterExcludedSelected.length === 0) ? JSON.parse(selected[0]).additionalData.type : "exclude"
                                    }
                                }
                            }
                        } else { // if matching selected not available - select the default
                            if (isGroupingData) { // if multi and grouped - select className of except _grouping
                                let tempFilter = fieldList.filter(f => f.className.split("_").slice(-1)[0] !== "grouping").map(m => JSON.parse(m.value))
                                selectedItems[indx] = tempFilter.length !== 0 ? tempFilter[0] : []
                                if (indexDef.valuesType === "Hotels") {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: tempFilter[0].map(s => JSON.parse(s)),
                                        valuesType: indexDef.valuesType,
                                        additionalData: ""
                                    }
                                } else {
                                    let filterExcludedSelected = selectedItems[indx].filter(s => JSON.parse(s).additionalData.type === "exclude");
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (filterExcludedSelected.length === 0) ?
                                            selectedItems[indx].map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]) :
                                            filterExcludedSelected.map(s => JSON.parse(s).additionalData.visibleVal),
                                        valuesType: indexDef.valuesType,
                                        additionalData: (filterExcludedSelected.length === 0) ? JSON.parse(selectedItems[indx][0]).additionalData.type : "exclude"
                                    }
                                }
                            } else { // if multi and not grouped - select all
                                let selItm = fieldList.map(f => f.value);
                                selectedItems[indx] = selItm;
                                if (indexDef.valuesType === "Hotels") {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: selItm.map(s => JSON.parse(s)),
                                        valuesType: indexDef.valuesType,
                                        additionalData: ""
                                    }
                                } else {
                                    let filterExcludedSelected = selItm.filter(s => JSON.parse(s).additionalData.type === "exclude");
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (filterExcludedSelected.length === 0) ?
                                            selItm.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]) :
                                            filterExcludedSelected.map(s => JSON.parse(s).additionalData.visibleVal).reduce((pre, cur) => pre.concat(cur),[]),
                                        valuesType: indexDef.valuesType,
                                        additionalData: (filterExcludedSelected.length === 0) ? JSON.parse(selItm[0]).additionalData.type : "exclude"
                                    }
                                }
                            }
                        }

                        if (selectedItems[indx].length !== 0) { // if selected items not empty
                            if (copiedChangedData[indx] !== undefined) { // if data change occured
                                if (copiedChangedData[indx]['groupedData'] !== undefined && !_.isEmpty(copiedChangedData[indx]['groupedData'])) { // if data change occured in Groups
                                    for (const grp of copiedChangedData[indx]['groupedData']) {
                                        let selectedchanged = selectedItems[indx].filter(s => {
                                            let sconv = JSON.parse(s);
                                            return sconv.userGroupId === grp.userGroupId && sconv.groupId === grp.groupId
                                        });

                                        if (selectedchanged.length !== 0) {
                                            compSearchData.current.isNewRequest = true;
                                            compSearchData.current.paginationReset = true;
                                            delete copiedChangedData[indx];
                                            if (width < 992) {
                                                setDrawerData({ ...drawerData, submitBtnDisable: false })
                                            }
                                            setGo({ ...go, isDisabled: false });
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    } else { // if not multi select
                        if (tempSelection.length > 1) { // if props.compSearchParams.triggerIndex has two values 
                            let sel = undefined;
                            sel = fieldList.find(f => {
                                let jsonF = JSON.parse(f.data);
                                if (jsonF.additionalData !== undefined && !_.isEmpty(jsonF.additionalData)) {
                                    return (_.isEqual(_.sortBy(jsonF.additionalData.val), _.sortBy(tempSelection)) || (jsonF.additionalData.val.find(s => tempSelection.includes(s)) !== undefined)); // include - incase if hotel reports allowed compliance having one type of category though secondary config have multiple category
                                } else {
                                    return false;
                                }
                            });

                            if (sel !== undefined) {
                                selectedItems[indx] = sel.value;
                                if ((JSON.parse(sel.data)).additionalData !== undefined && !_.isEmpty((JSON.parse(sel.data)).additionalData)) {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (JSON.parse(sel.data)).additionalData.visibleVal,
                                        valuesType: indexDef.valuesType,
                                        additionalData: (JSON.parse(sel.data)).additionalData.type
                                    }
                                } else {//=> though category dropdown available with selection, No special condition need to filter reports
                                    delete compSearchData.current.searchData[indx];
                                }
                            } else {
                                // if matching not found select default
                                selectedItems[indx] = fieldList.length !== 0 ? fieldList[0].value : "";
                                if ((JSON.parse(fieldList[0].data)).additionalData !== undefined && !_.isEmpty((JSON.parse(fieldList[0].data)).additionalData)) {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (JSON.parse(fieldList[0].data)).additionalData.visibleVal,
                                        valuesType: indexDef.valuesType,
                                        additionalData: (JSON.parse(fieldList[0].data)).additionalData.type
                                    }
                                } else {//=> though category dropdown available with selection, No special condition need to filter reports
                                    delete compSearchData.current.searchData[indx];
                                }
                            }

                        } else {
                            let sel = undefined;
                            sel = fieldList.find(f => f.value === tempSelection[0]);
                            if (sel !== undefined) {
                                selectedItems[indx] = sel.value;
                                if ((JSON.parse(sel.data)).additionalData !== undefined && !_.isEmpty((JSON.parse(sel.data)).additionalData)) {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (JSON.parse(sel.data)).additionalData.visibleVal,
                                        valuesType: indexDef.valuesType,
                                        additionalData: (JSON.parse(sel.data)).additionalData.type
                                    }
                                } else {//=> though category dropdown available with selection, No special condition need to filter reports
                                    delete compSearchData.current.searchData[indx];
                                }
                            } else { // if matching not found select default
                                selectedItems[indx] = fieldList.length !== 0 ? fieldList[0].value : "";
                                if ((JSON.parse(fieldList[0].data)).additionalData !== undefined && !_.isEmpty((JSON.parse(fieldList[0].data)).additionalData)) {
                                    compSearchData.current.searchData[indx] = {
                                        searchVal: (JSON.parse(fieldList[0].data)).additionalData.visibleVal,
                                        valuesType: indexDef.valuesType,
                                        additionalData: (JSON.parse(fieldList[0].data)).additionalData.type
                                    }
                                } else {//=> though category dropdown available with selection, No special condition need to filter reports
                                    delete compSearchData.current.searchData[indx];
                                }
                            }
                        }
                    }

                    let dropdownIndx = {
                        name: indexDef.name,
                        order: indexDef.order,
                        type: indexDef.type.toLowerCase(),
                        valuesType: indexDef.valuesType,
                        values: fieldList,
                        selectedValue: selectedItems[indx],
                        grouped: isGroupingData,
                        groupingMode: groupingMode,
                        mode: multiSelect === true ? dropDownConfigs.mode.MULTIPLE : dropDownConfigs.mode.SINGLE,
                        indexCategory: indexType,
                        onChangeFn: setTriggeredFilterData,
                        onGroupingUpdateFn:
                            (isGroupingData === true && //since using on delete
                                _.some(groupingMode, (m) => {
                                    return [dropDownConfigs.groupingMode.CREATE, dropDownConfigs.groupingMode.EDIT, dropDownConfigs.groupingMode.DELETE].includes(m)
                                }) === true) ?
                                setUpdatedCurrentProjData : null

                    }

                    let dropdwnobj = CreateDropDown(dropdownIndx);
                    tempFilter.push(dropdwnobj);

                }

                if (err) {
                    selectedItems[indx] = multiSelect ? [] : "";
                    delete compSearchData.current.searchData[indx];
                    let dropdownIndx = {
                        name: indexDef.name,
                        order: indexDef.order,
                        type: indexDef.type.toLowerCase(),
                        valuesType: indexDef.valuesType,
                        values: [],
                        selectedValue: selectedItems[indx],
                        grouped: isGroupingData,
                        groupingMode: groupingMode,
                        mode: multiSelect === true ? dropDownConfigs.mode.MULTIPLE : dropDownConfigs.mode.SINGLE,
                        indexCategory: indexType,
                        onChangeFn: setTriggeredFilterData,
                        onGroupingUpdateFn:
                            (isGroupingData === true && //since using on delete
                                _.some(groupingMode, (m) => {
                                    return [dropDownConfigs.groupingMode.CREATE, dropDownConfigs.groupingMode.EDIT, dropDownConfigs.groupingMode.DELETE].includes(m)
                                }) === true) ?
                                setUpdatedCurrentProjData : null

                    }

                    let dropdwnobj = CreateDropDown(dropdownIndx);
                    ejectableIndexes.push(dropdwnobj);
                }
            }
        }

        if (!errClosure) {
            for (const filter of tempFilter) {
                let fIndex = _.findIndex(filterObjArr, (e => e.key === filter.key));
                if (fIndex === -1) {
                    filterObjArr = [...filterObjArr, filter];
                    _.sortBy(filterObjArr, [props.indexOrder]);
                } else {
                    filterObjArr.splice(fIndex, 1, filter)
                }

            }

            // if error occured in an index field (eg: no matching data) eject the filter without showing additional error messages
            if (ejectableIndexes.length !== 0) {
                for (const efilter of ejectableIndexes) {
                    let fIndex = _.findIndex(filterObjArr, (e => e.key === efilter.key));
                    if (fIndex !== -1) {
                        filterObjArr.splice(fIndex, 1)
                    }
                }
            }

            // At initial load get list of controlled filters (hotel select dropdown with apply button, rangepicker with apply button) with initial state as open=false
            if (compSearchData.current.isInitialReq) {
                if (filterObjArr.length !== 0) {
                    let filterStates = {}
                    for (let index = 0; index < filterObjArr.length; index++) {
                        const element = filterObjArr[index];
                        if (element.props.apply === dropDownConfigs.apply.ONAPPLY || element.props.apply === datePickerConfigs.apply.ONAPPLY) {
                            filterStates[element.props.indexName] = false
                        }

                    }
                    dispatch(controlledComponentsActions.setControlledFiltersOpen(filterStates))
                }
            }

            setFilterObjs(filterObjArr);
            let copiedIndexSelectedProjData = JSON.parse(JSON.stringify(tempcopiedSelectedProjData[indexType]));
            copiedIndexSelectedProjData[complianceMainTabActive] = selectedItems; //have to check at the errors
            setSelectedProjData({ ...selectedProjData, [indexType]: copiedIndexSelectedProjData });
            return;
        }
    }

    const applyData = () => { // applied filter data send to table creation request (HotelBaseCompliance)
        compSearchData.current.managementGroup = currentHMG.hmg;
        compSearchData.current.solution = currentSol[complianceMainTabActive].sol;
        compSearchData.current.pms = (props.compSearchParams !== null && props.compSearchParams.pms !== undefined) ? props.compSearchParams.pms : null;
        compSearchData.current.userEmail = loggedUserData.userEmail;
        compSearchData.current.selectedCustomViewTab = complianceMainTabActive;
        compSearchData.current.isCustomTriggersAvailable = (currentSolSecTriggerData[complianceMainTabActive].length !== 0 ? true : false)
        compSearchData.current.appConfigSoftLiveType = selectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive] !== undefined ? selectedExtraProjData.appConfigSoftLiveType[complianceMainTabActive] : null;
        if (compSearchData.current.reportIdx === null) { //later should edit this to altSearchIdx in front and backend
            compSearchData.current.reportIdx = selectedExtraProjData.altSearchIdx[complianceMainTabActive] !== undefined ? 
                (selectedExtraProjData.altSearchIdx[complianceMainTabActive].find(a=> a.valuesType === "Report") !== undefined ? 
                    selectedExtraProjData.altSearchIdx[complianceMainTabActive].find(a=> a.valuesType === "Report").indexName 
                    : null
                ) 
                : null;
        }

        if (currentSolSecTriggerData[complianceMainTabActive].length !== 0) {
            let validTrigs = [];
            if (compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE") === 'Daily') {
                validTrigs = currentSolSecTriggerData[complianceMainTabActive]
            } else {
                validTrigs = currentSolSecTriggerData[complianceMainTabActive].filter(c => c.envlopeTriggerScheduleType === compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE"))
            }

            if (validTrigs.length !== 0) {
                let tempsearchDataList = {};
                for (const validTrig of validTrigs) {
                    if (Object.entries(compSearchData.current.searchData).find(([k, v]) => k === validTrig.envlopeTriggerIndex) === undefined) { // if secondary triggerindex not in searchData - add (due to not having the index filter)
                        tempsearchDataList[validTrig.envlopeTriggerIndex] = {
                            searchVal: tempsearchDataList[validTrig.envlopeTriggerIndex] !== undefined ? tempsearchDataList[validTrig.envlopeTriggerIndex].searchVal.concat(validTrig.envlopeTriggerIndexValue) : validTrig.envlopeTriggerIndexValue,
                            valuesType: validTrig.envlopeTriggerIndex,
                            additionalData: compViewskeyMapper(complianceMainTabActive, "KEY", "VALUE") === 'Daily' ? "exclude" : "include"
                        }
                    }
                } 
                compSearchData.current.searchData = _.merge(compSearchData.current.searchData, tempsearchDataList);
            }
        }

        let copyOfselectedProjData = JSON.parse(JSON.stringify(selectedProjData));
        let copyOfselectedExtraProjData = JSON.parse(JSON.stringify(selectedExtraProjData));
        //if go clicked save the applied data that can be used in tab change
        //Eg: in default tab change done but not clicked on Go but change to other tab, if come back to default tab non changed applied data need to be load by using appliedSelectedProjData
        let tempAppliedFiltered = { ...appliedSelectedProjData };
        for (const indexkey in copyOfselectedProjData) {
            if (copyOfselectedProjData[indexkey][complianceMainTabActive] !== undefined) {
                tempAppliedFiltered[indexkey][complianceMainTabActive] = copyOfselectedProjData[indexkey][complianceMainTabActive];
            }
        }
        for (const indexkey in copyOfselectedExtraProjData) {
            if (copyOfselectedExtraProjData[indexkey][complianceMainTabActive] !== undefined) {
                tempAppliedFiltered[indexkey][complianceMainTabActive] = copyOfselectedExtraProjData[indexkey][complianceMainTabActive];
            }
        }
        setAppliedSelectedProjData({ ...tempAppliedFiltered });

        if (compSearchData.current.isInitialReq === true) {
            //if init req. save initial loads to initialSelectedProjData to identify Reset btn visibility when tab change not for 1st time by changed count
            let tempFiltered = { ...initialSelectedProjData };
            for (const indexkey in copyOfselectedProjData) {
                if (copyOfselectedProjData[indexkey][complianceMainTabActive] !== undefined) {
                    tempFiltered[indexkey][complianceMainTabActive] = copyOfselectedProjData[indexkey][complianceMainTabActive];
                }
            }
            for (const indexkey in copyOfselectedExtraProjData) {
                if (copyOfselectedExtraProjData[indexkey][complianceMainTabActive] !== undefined) {
                    tempFiltered[indexkey][complianceMainTabActive] = copyOfselectedExtraProjData[indexkey][complianceMainTabActive];
                }
            }
            setInitialSelectedProjData({ ...tempFiltered });
            //if initial req.(HMG change, solution change, onLoad, reset clicked and set to as initial req) - reset btn invisible and not applied
            setReset({ ...reset, visibility: false, resetApplied: false });
        } else { //if not initialreq. change has happened so reset btn should be visible
            setReset({ ...reset, visibility: true });
        }

        props.updateSearchData(compSearchData.current);

        if (reset.resetApplied) {
            setReset({ ...reset, visibility: false, resetApplied: false });
        }

        /* if switched from big screen to small screen(tab device rotate) while filter changes were done (go.isDisabled=false),
        incase in mobile view data got applied should change the go.isDisabled=true to avoid inconsistancy at change to large view again*/
        setGo({ ...go, dataApplied: false, isDisabled: true });
        setDrawerData({
            ...drawerData,
            visibility: false,
            dataApplied: false,
            dataReset: false,
            submitBtnDisable: true,
            closeBtnDisable: false,
            dataAppliedCount: getDrawerFiltersChangesCount() //specially to update count when selected group deleted which sets to default
        });

        setTriggeredFilterData({});//reset filter selection trigger once data search applied
        //if apply button is clicked - remove the update/delete group data from ref else keep till get applied for the comparision of selected items
        if (filterUpdatedData.current.changedData[complianceMainTabActive] !== undefined && !_.isEmpty(filterUpdatedData.current.changedData[complianceMainTabActive])) {
            let tempfilterChangedData = { ...filterUpdatedData.current.changedData };
            delete tempfilterChangedData[complianceMainTabActive];
            filterUpdatedData.current.changedData = tempfilterChangedData;
        }
        compSearchData.current.isInitialReq = false;
        compSearchData.current.isNewRequest = false;
        compSearchData.current.paginationReset = false;
        return;
    }

    const clearFilterData = () => { // clear the filters applied - Set the initial filter selections through ref method
        let copyOfCurrentSelectedProjData = JSON.parse(JSON.stringify(selectedProjData));
        let copyOfInitialSelectedProjData = JSON.parse(JSON.stringify(initialSelectedProjData));

        if (copyOfInitialSelectedProjData.l1_Indexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.l1_Indexes[complianceMainTabActive] = copyOfInitialSelectedProjData.l1_Indexes[complianceMainTabActive];
        }
        if (copyOfInitialSelectedProjData.l2_Indexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.l2_Indexes[complianceMainTabActive] = copyOfInitialSelectedProjData.l2_Indexes[complianceMainTabActive];
        }
        if (copyOfInitialSelectedProjData.l3_Indexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.l3_Indexes[complianceMainTabActive] = copyOfInitialSelectedProjData.l3_Indexes[complianceMainTabActive];
        }
        if (copyOfInitialSelectedProjData.l4_Indexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.l4_Indexes[complianceMainTabActive] = copyOfInitialSelectedProjData.l4_Indexes[complianceMainTabActive];
        }
        if (copyOfInitialSelectedProjData.l5_Indexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.l5_Indexes[complianceMainTabActive] = copyOfInitialSelectedProjData.l5_Indexes[complianceMainTabActive];
        }
        if (copyOfInitialSelectedProjData.independentIndexes[complianceMainTabActive] !== undefined) {
            copyOfCurrentSelectedProjData.independentIndexes[complianceMainTabActive] = copyOfInitialSelectedProjData.independentIndexes[complianceMainTabActive];
        }

        if (copyOfCurrentSelectedProjData.l1_Indexes[complianceMainTabActive] !== undefined || copyOfCurrentSelectedProjData.independentIndexes[complianceMainTabActive] !== undefined) {
            filterUpdatedData.current.selectedProjDataChanged.isChanged = true;
            filterUpdatedData.current.selectedProjDataChanged.changedData = copyOfCurrentSelectedProjData;
        }

        setGo({ ...go, dataApplied: false, isDisabled: true });
        setDrawerData({ ...drawerData, visibility: false, dataApplied: false, dataReset: false, submitBtnDisable: true, closeBtnDisable: false, dataAppliedCount: 0 });
        handleHMG(currentHMG.hmg);
    }

    const getFiltersSelectionChangesCount = (currentFilterSelections, comparingFilterSelections) => {
        let filtersChangedCount = 0;
        for (const indexLvlkey in comparingFilterSelections) {
            if (currentFilterSelections[indexLvlkey] !== undefined) {
                if (comparingFilterSelections[indexLvlkey][complianceMainTabActive] !== undefined && currentFilterSelections[indexLvlkey][complianceMainTabActive] !== undefined) {
                    for (const filterKey in comparingFilterSelections[indexLvlkey][complianceMainTabActive]) {
                        if (currentFilterSelections[indexLvlkey][complianceMainTabActive][filterKey] !== undefined) {
                            let stringifiedFilterData = JSON.stringify(currentFilterSelections[indexLvlkey][complianceMainTabActive][filterKey]);
                            let stringifiedInitFilterData = JSON.stringify(comparingFilterSelections[indexLvlkey][complianceMainTabActive][filterKey]);
                            if (stringifiedFilterData !== stringifiedInitFilterData) {
                                filtersChangedCount += 1;
                            }
                        }
                    }
                }
            }
        }
        return filtersChangedCount;
    }
    const getDrawerFiltersChangesCount = () => {
        let filtersChangedCount = 0;
        let drawerFilters = [...styledFilter.drawerFilters];
        if (width < 992) { //small devices
            for (const indexLvlkey in selectedProjData) {
                if (_.find(drawerFilters, f => f.props.indexCategory === indexLvlkey) !== undefined) {
                    if (selectedProjData[indexLvlkey][complianceMainTabActive] !== undefined && !_.isEmpty(selectedProjData[indexLvlkey][complianceMainTabActive])) {
                        for (const filterKey in selectedProjData[indexLvlkey][complianceMainTabActive]) {
                            if (_.find(drawerFilters, f => f.props.indexName === filterKey) !== undefined) {
                                let stringifiedFilterData = JSON.stringify(selectedProjData[indexLvlkey][complianceMainTabActive][filterKey]);
                                let stringifiedInitFilterData = JSON.stringify(initialSelectedProjData[indexLvlkey][complianceMainTabActive][filterKey]);
                                if (stringifiedFilterData !== stringifiedInitFilterData) {
                                    filtersChangedCount += 1;
                                }
                            }

                        }
                    }
                }
            }
        }

        return filtersChangedCount;
    }

    const drawerCloseFunc = (updatedProps) => {
        let copyOfFilterStates = JSON.parse(JSON.stringify(isControlledFiltersOpen));
        for (const key in copyOfFilterStates) {
            copyOfFilterStates[key] = false;
        }
        dispatch(actions.setControlledFiltersOpen(copyOfFilterStates));
        // let merged = _.merge(updatedProps, { dataAppliedCount: drawerData.dataAppliedCount })
        // setDrawerData(merged)
        setDrawerData({ ...drawerData, ...updatedProps })
    }

    const setUpdatedCurrentProjData = useCallback((indexName, indexValueType, dataType, updatedData, changedData, action) => {//for dropdown group create/update/delete
        /** Hotels,hotels,"groupedData",updated dropdown list, updated selection,CREATE  */
        if (indexName !== "" && indexValueType !== "") {
            dispatch(controlledComponentsActions.setLoaderStatus(true));
            let projTabList = [];
            if (_.size(currentSol) > 1) {
                let currentSolData = Object.fromEntries(Object.entries(currentSol).filter(([key]) => key.includes(complianceMainTabActive)));
                let currentSolProjId = currentSolData[complianceMainTabActive].projId;
                projTabList = Object.keys(Object.fromEntries(Object.entries(currentSol).filter(([key, value]) => value.projId === currentSolProjId)))
            } else {
                projTabList.push(complianceMainTabActive);
            }


            let tempObj = { ...filterUpdatedData.current };
            for (const projTab of projTabList) {
                let indexType = undefined;
                for (const key in currentIndexes[projTab]) {
                    let index = currentIndexes[projTab][key].find(i => i.name === indexName && i.valuesType === indexValueType);
                    if (index !== undefined) {
                        indexType = key;
                        break;
                    }
                }
                if (indexType !== undefined) {
                    if (tempObj.updatedData[projTab] === undefined) {
                        tempObj.updatedData[projTab] = {
                            [indexType]: {
                                [indexName]: {
                                    [dataType]: updatedData
                                }
                            }
                        }
                    } else {
                        if (tempObj.updatedData[projTab][indexType] === undefined) {
                            tempObj.updatedData[projTab][indexType] = {
                                [indexName]: {
                                    [dataType]: updatedData
                                }
                            }
                        } else {
                            if (tempObj.updatedData[projTab][indexType][indexName] === undefined) {
                                tempObj.updatedData[projTab][indexType][indexName] = {
                                    [dataType]: updatedData
                                }
                            } else {
                                tempObj.updatedData[projTab][indexType][indexName][dataType] = updatedData
                            }
                        }
                    }

                    //TODO check changedData empty
                    if (tempObj.changedData[projTab] === undefined) {
                        tempObj.changedData[projTab] = {
                            [indexType]: {
                                [indexName]: {
                                    [dataType]: changedData
                                }
                            }
                        }
                    } else {
                        if (tempObj.changedData[projTab][indexType] === undefined) {
                            tempObj.changedData[projTab][indexType] = {
                                [indexName]: {
                                    [dataType]: changedData
                                }
                            }
                        } else {
                            if (tempObj.changedData[projTab][indexType][indexName] === undefined) {
                                tempObj.changedData[projTab][indexType][indexName] = {
                                    [dataType]: changedData
                                }
                            } else {
                                tempObj.changedData[projTab][indexType][indexName][dataType] = (tempObj.changedData[projTab][indexType][indexName][dataType]).concat(changedData)
                            }
                        }
                    }
                    filterUpdatedData.current = tempObj;
                }
            }
            if (!_.isEmpty(tempObj.changedData) || (_.isEmpty(tempObj.changedData) && !_.isEmpty(tempObj.updatedData))) {
                let currentindexType = undefined;
                for (const key in currentIndexes[complianceMainTabActive]) {
                    let index = currentIndexes[complianceMainTabActive][key].find(i => i.name === indexName && i.valuesType === indexValueType);
                    if (index !== undefined) {
                        currentindexType = key;
                        break;
                    }
                }
                if (currentindexType !== undefined) {
                    processCurrentIndexes(currentindexType, 'updated');
                }
            }
        }
    }, [currentIndexes, complianceMainTabActive, currentSol, processCurrentIndexes])

    //make compSearchParams=null at tab change (to get at initial load)
    //event at onchange of filters call make compSearchParams={} (updateFilterData)

    useEffect(() => {
        handleHMG();
    }, [props.projectDetails]);

    useEffect(() => { // get prev states and new states to compare when progressing 
        if (currentHMG.hmg !== "" && currentHMG.entityId !== "") {
            resetSessData();
            let copyOfappliedSelectedProjData = JSON.parse(JSON.stringify(appliedSelectedProjData));
            let SelectedExtraProjDataKeys = Object.keys(selectedExtraProjData);
            const filtered = Object.keys(copyOfappliedSelectedProjData)
                .filter(key => SelectedExtraProjDataKeys.includes(key))
                .reduce((obj, key) => {
                    obj[key] = copyOfappliedSelectedProjData[key];
                    return obj;
                }, {});
            delete copyOfappliedSelectedProjData.appConfigSoftLiveType;
            delete copyOfappliedSelectedProjData.altSearchIdx;
            if (copyOfappliedSelectedProjData.l1_Indexes[complianceMainTabActive] !== undefined || copyOfappliedSelectedProjData.independentIndexes[complianceMainTabActive] !== undefined) {
                filterUpdatedData.current.selectedProjDataChanged.isChanged = true;
                filterUpdatedData.current.selectedProjDataChanged.changedData = copyOfappliedSelectedProjData;
            }
            if (filtered.appConfigSoftLiveType[complianceMainTabActive] !== undefined) {
                filterUpdatedData.current.selectedExtraProjDataChanged.isChanged = true;
                filterUpdatedData.current.selectedExtraProjDataChanged.changedData = filtered;
            }
            setTriggeredFilterData({});
            setReset({ ...reset, visibility: false, resetApplied: false });
            if (width >= 992) {
                setGo({ ...go, dataApplied: false, isDisabled: true });
                setDrawerData({ ...drawerData, submitBtnDisable: true });
            }
            handleHMG(currentHMG.hmg);
        }
    }, [complianceMainTabActive]);

    useEffect(() => {
        if (currentHMG.hmg !== "" && currentHMG.entityId !== "") {
            if (prevCurrentHMG.hmg !== currentHMG.hmg) {
                unmountFilterObjsExcept("HMG");
                if (!_.isEmpty(currentSol)) { //when hmg change
                    filterUpdatedData.current.changedData = {};
                    filterUpdatedData.current.updatedData = {};
                    setCurrentSol({});
                    setCurrentIndexes({})
                    setCurrentProj({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {} })
                    setSelectedProjData({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {} })
                    setSelectedExtraProjData({ appConfigSoftLiveType: {}, altSearchIdx: {} });
                    setAppliedSelectedProjData({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {}, appConfigSoftLiveType: {}, altSearchIdx: {} });
                    setInitialSelectedProjData({ l1_Indexes: {}, l2_Indexes: {}, l3_Indexes: {}, l4_Indexes: {}, l5_Indexes: {}, independentIndexes: {}, appConfigSoftLiveType: {}, altSearchIdx: {} });
                    setDrawerData({ ...drawerData, visibility: false, dataApplied: false, dataReset: false, submitBtnDisable: true, closeBtnDisable: false, dataAppliedCount: 0 });
                } else { // when initial load
                    handleSol();
                }
            } else { //when tab change
                handleSol();
            }

        }
    }, [currentHMG]);

    useEffect(() => {
        //TODO: if projectid and entityid of both views same no need to call getAppConfig API - instead call a function to set app config data to indexes
        if (currentHMG.entityId !== "" && currentHMG.hmg !== "") { //hmg available
            if (!_.isEmpty(currentSol) && currentSol[complianceMainTabActive].projId !== undefined) {
                if (currentSol[complianceMainTabActive].projId !== "") {
                    if (currentIndexes[prevComplianceMainTabActive] === undefined || currentSol[prevComplianceMainTabActive].projId !== currentSol[complianceMainTabActive].projId) {
                        // if (_.isEmpty(currentIndexes) || currentSol[prevComplianceMainTabActive].projId !== currentSol[complianceMainTabActive].projId) {
                        let selectedProjectData = [{
                            entityId: currentHMG.entityId,
                            projectId: currentSol[complianceMainTabActive].projId
                        }];
                        let pms = (props.compSearchParams !== null && props.compSearchParams.pms !== undefined) ? props.compSearchParams.pms : "";
                        let searchData = {
                            userName: loggedUserData.rawUserName,
                            projDetails: selectedProjectData,
                            datailsForApp: apps.COMPLIANCE,
                            pms: pms,
                        };
                        //remove the complianceMainTabActive from CurrentIndexes, CurrentProj, SelectedProjData
                        let tempCurrentIndexes = { ...currentIndexes };
                        delete tempCurrentIndexes[complianceMainTabActive];
                        let tempCurrentProj = { ...currentProj };
                        for (const index in tempCurrentProj) {
                            delete tempCurrentProj[index][complianceMainTabActive];
                        }
                        let tempSelectedProjData = { ...selectedProjData };
                        for (const index in tempSelectedProjData) {
                            delete tempSelectedProjData[index][complianceMainTabActive];
                        }
                        let tempSelectedExtraProjData = { ...selectedExtraProjData };
                        for (const index in tempSelectedExtraProjData) {
                            delete tempSelectedExtraProjData[index][complianceMainTabActive];
                        }

                        setCurrentIndexes(tempCurrentIndexes);
                        setCurrentProj(tempCurrentProj);
                        setSelectedProjData(tempSelectedProjData);
                        setSelectedExtraProjData(tempSelectedExtraProjData);
                        dispatch(qmsApiActions.getAppConfig(searchData));
                    } else {
                        processAppconfigData();
                    }
                }
            } else { //new solution not set when cleared after hmg change
                handleSol();
            }
        }
    }, [currentSol]);

    useEffect(() => {
        processAppconfigData();
    }, [appConfigData]);

    useEffect(() => {
        if (!_.isEmpty(currentIndexes) && currentIndexes[complianceMainTabActive] !== undefined) {
            if (common.loading !== true && common.error === null) {
                if (currentIndexes[complianceMainTabActive].l1_Indexes.length !== 0 && currentProj.l1_Indexes[complianceMainTabActive] === undefined) {
                    if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                        if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l1_Indexes'] !== undefined) {
                            processCurrentIndexes('l1_Indexes', 'updated');
                        } else {
                            processCurrentIndexes('l1_Indexes');
                        }
                    } else {
                        processCurrentIndexes('l1_Indexes');
                    }
                } else if (currentIndexes[complianceMainTabActive].l2_Indexes.length === 0) {
                    if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                processCurrentIndexes('independentIndexes', 'updated');
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }
                        } else {
                            processCurrentIndexes('independentIndexes');
                        }
                    }
                }
            }
        }

    }, [currentIndexes, holisticData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.l1_Indexes) && currentProj.l1_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.l1_Indexes[complianceMainTabActive])) {
                if (common.loading !== true && common.error === null) {
                    if (currentIndexes[complianceMainTabActive].l2_Indexes.length !== 0 && currentProj.l2_Indexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l2_Indexes'] !== undefined) {
                                processCurrentIndexes('l2_Indexes', 'updated');
                            } else {
                                processCurrentIndexes('l2_Indexes');
                            }
                        } else {
                            processCurrentIndexes('l2_Indexes');
                        }

                    } else if (currentIndexes[complianceMainTabActive].l3_Indexes.length === 0) {
                        if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                            if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                                if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                    processCurrentIndexes('independentIndexes', 'updated');
                                } else {
                                    processCurrentIndexes('independentIndexes');
                                }
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }

                        } else {
                            // execute process selected
                            handleIndexProjData('l1_Indexes');
                        }
                    }
                }
            }
        }
    }, [currentProj.l1_Indexes, holisticData, categoryReportData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.l2_Indexes) && currentProj.l2_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.l2_Indexes[complianceMainTabActive])) {
                if (common.loading !== true && common.error === null) {
                    if (currentIndexes[complianceMainTabActive].l3_Indexes.length !== 0 && currentProj.l3_Indexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l3_Indexes'] !== undefined) {
                                processCurrentIndexes('l3_Indexes', 'updated');
                            } else {
                                processCurrentIndexes('l3_Indexes');
                            }
                        } else {
                            processCurrentIndexes('l3_Indexes');
                        }
                    } else if (currentIndexes[complianceMainTabActive].l4_Indexes.length === 0) {
                        if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                            if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                                if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                    processCurrentIndexes('independentIndexes', 'updated');
                                } else {
                                    processCurrentIndexes('independentIndexes');
                                }
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }
                        } else {
                            // execute process selected
                            handleIndexProjData('l1_Indexes');
                        }
                    }
                }
            }
        }
    }, [currentProj.l2_Indexes, holisticData, categoryReportData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.l3_Indexes) && currentProj.l3_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.l3_Indexes[complianceMainTabActive])) {
                if (common.loading !== true && common.error === null) {
                    if (currentIndexes[complianceMainTabActive].l4_Indexes.length !== 0 && currentProj.l4_Indexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l4_Indexes'] !== undefined) {
                                processCurrentIndexes('l4_Indexes', 'updated');
                            } else {
                                processCurrentIndexes('l4_Indexes');
                            }
                        } else {
                            processCurrentIndexes('l4_Indexes');
                        }
                        processCurrentIndexes('l4_Indexes');
                    } else if (currentIndexes[complianceMainTabActive].l5_Indexes.length === 0) {
                        if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                            if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                                if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                    processCurrentIndexes('independentIndexes', 'updated');
                                } else {
                                    processCurrentIndexes('independentIndexes');
                                }
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }
                        } else {
                            // execute process selected
                            handleIndexProjData('l1_Indexes');
                        }
                    }
                }
            }
        }
    }, [currentProj.l3_Indexes, holisticData, categoryReportData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.l4_Indexes) && currentProj.l4_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.l4_Indexes[complianceMainTabActive])) {
                if (common.loading !== true && common.error === null) {
                    if (currentIndexes[complianceMainTabActive].l5_Indexes.length !== 0 && _.isEmpty(currentProj.l5_Indexes[complianceMainTabActive])) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['l5_Indexes'] !== undefined) {
                                processCurrentIndexes('l5_Indexes', 'updated');
                            } else {
                                processCurrentIndexes('l5_Indexes');
                            }
                        } else {
                            processCurrentIndexes('l5_Indexes');
                        }
                    } else if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                processCurrentIndexes('independentIndexes', 'updated');
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }
                        } else {
                            processCurrentIndexes('independentIndexes');
                        }
                    } else {
                        // execute process selected
                        handleIndexProjData('l1_Indexes');
                    }
                }
            }
        }
    }, [currentProj.l4_Indexes, holisticData, categoryReportData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.l5_Indexes) && currentProj.l5_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.l5_Indexes[complianceMainTabActive])) {
                if (common.loading !== true && common.error === null) {
                    if (currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 && currentProj.independentIndexes[complianceMainTabActive] === undefined) {
                        if (!_.isEmpty(filterUpdatedData.current.updatedData) && filterUpdatedData.current.updatedData[complianceMainTabActive] !== undefined) {
                            if (filterUpdatedData.current.updatedData[complianceMainTabActive]['independentIndexes'] !== undefined) {
                                processCurrentIndexes('independentIndexes', 'updated');
                            } else {
                                processCurrentIndexes('independentIndexes');
                            }
                        } else {
                            processCurrentIndexes('independentIndexes');
                        }
                    } else {
                        // execute process selected
                        handleIndexProjData('l1_Indexes');
                    }
                }
            }
        }
    }, [currentProj.l5_Indexes, holisticData, categoryReportData]);

    useEffect(() => {
        if (!_.isEmpty(currentProj.independentIndexes) && currentProj.independentIndexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(currentProj.independentIndexes[complianceMainTabActive])) {
                // execute process selected
                if (currentIndexes[complianceMainTabActive].l1_Indexes.length !== 0 && currentProj.l1_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l1_Indexes[complianceMainTabActive])) {
                    handleIndexProjData('l1_Indexes');
                } else {
                    handleIndexProjData('independentIndexes');
                }
            }

        }
    }, [currentProj.independentIndexes]);


    useEffect(() => {
        if (!_.isEmpty(selectedProjData.l1_Indexes) && selectedProjData.l1_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.l1_Indexes[complianceMainTabActive])) {
                if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].l2_Indexes.length !== 0 &&
                    currentProj.l2_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l2_Indexes[complianceMainTabActive])) {
                    handleIndexProjData('l2_Indexes');
                } else if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 &&
                    currentProj.independentIndexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.independentIndexes[complianceMainTabActive]) &&
                    (_.isEmpty(selectedProjData.independentIndexes) || (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] === undefined))) {
                    handleIndexProjData('independentIndexes');
                } else {
                    // reset after setting
                    filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                    filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                    if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                        compSearchData.current.isInitialReq = true
                        compSearchData.current.isNewRequest = true;
                        compSearchData.current.paginationReset = true;
                        applyData();
                    } else {
                        if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                            applyData();
                        } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                            let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                            if(isFilterOnChange.current){ //onchange selection
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    setGo({ ...go, isDisabled: false });
                                    //if drawer open, check changes done on drawers or not for submit btn disable
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, submitBtnDisable: false })
                                    } else { //large screen devices
                                        if(drawerData.visibility){
                                            let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                            if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                                setDrawerData({ ...drawerData, submitBtnDisable: false });
                                            } else { // if no change than previous selection
                                                setDrawerData({ ...drawerData, submitBtnDisable: true });
                                            }
                                        }
                                    }
                                } else { // if no change than previously applied selection
                                    compSearchData.current.isNewRequest = false;
                                    compSearchData.current.paginationReset = false;
                                    setGo({ ...go, isDisabled: true });
                                    setDrawerData({ ...drawerData, submitBtnDisable: true })
                                }
                                isFilterOnChange.current = false;
                            } else { //tab change/drawer cancel clicked
                                if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                    setDrawerData({ ...drawerData, dataReset: false });
                                    /** checking whether filters out of drawer has changed*/
                                    if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                        compSearchData.current.isNewRequest = true;
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                            if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                                let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                if(stringifiedFilterData !== stringifiedInitFilterData){
                                                    compSearchData.current.paginationReset = true;
                                                }
                                            }
                                        }
                                        setGo({ ...go, isDisabled: false });
                                    } else { // if no change than previously applied selection
                                        setGo({ ...go, isDisabled: true });
                                    }
                                } else { // tab change
                                    let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                    if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                        setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                    } else {//if selections not changed than initial
                                        setReset({ ...reset, visibility: false, resetApplied: false });
                                    }
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                    }
                                }
                            }
                            dispatch(controlledComponentsActions.setLoaderStatus(false));
                        }
                    }
                }
            } else {
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No selection on first level filters",
                    app: apps.COMPLIANCE
                });
            }
        }
    }, [selectedProjData.l1_Indexes]);

    useEffect(() => {
        if (!_.isEmpty(selectedProjData.l2_Indexes) && selectedProjData.l2_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.l2_Indexes[complianceMainTabActive])) {
                if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].l3_Indexes.length !== 0 &&
                    currentProj.l3_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l3_Indexes[complianceMainTabActive])) {
                    handleIndexProjData('l3_Indexes');
                } else if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 &&
                    currentProj.independentIndexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.independentIndexes[complianceMainTabActive]) &&
                    (_.isEmpty(selectedProjData.independentIndexes) || (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] === undefined))) {
                    handleIndexProjData('independentIndexes');
                } else {
                    // reset after setting
                    filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                    filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                    if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                        compSearchData.current.isInitialReq = true
                        compSearchData.current.isNewRequest = true;
                        compSearchData.current.paginationReset = true;
                        applyData();
                    } else {
                        if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                            applyData();
                        } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                            let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                            if(isFilterOnChange.current){ //onchange selection
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    setGo({ ...go, isDisabled: false });
                                    //if drawer open, check changes done on drawers or not for submit btn disable
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, submitBtnDisable: false })
                                    } else { //large screen devices
                                        if(drawerData.visibility){
                                            let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                            if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                                setDrawerData({ ...drawerData, submitBtnDisable: false });
                                            } else { // if no change than previous selection
                                                setDrawerData({ ...drawerData, submitBtnDisable: true });
                                            }
                                        }
                                    }
                                } else { // if no change than previously applied selection
                                    compSearchData.current.isNewRequest = false;
                                    compSearchData.current.paginationReset = false;
                                    setGo({ ...go, isDisabled: true });
                                    setDrawerData({ ...drawerData, submitBtnDisable: true })
                                }
                                isFilterOnChange.current = false;
                            } else { //tab change/drawer cancel clicked
                                if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                    setDrawerData({ ...drawerData, dataReset: false });
                                    /** checking whether filters out of drawer has changed*/
                                    if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                        compSearchData.current.isNewRequest = true;
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                            if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                                let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                if(stringifiedFilterData !== stringifiedInitFilterData){
                                                    compSearchData.current.paginationReset = true;
                                                }
                                            }
                                        }
                                        setGo({ ...go, isDisabled: false });
                                    } else { // if no change than previously applied selection
                                        setGo({ ...go, isDisabled: true });
                                    }
                                } else { // tab change
                                    let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                    if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                        setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                    } else {//if selections not changed than initial
                                        setReset({ ...reset, visibility: false, resetApplied: false });
                                    }
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                    }
                                }
                            }
                            dispatch(controlledComponentsActions.setLoaderStatus(false));
                        }
                    }
                }
            } else {
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No selection on second level filters",
                    app: apps.COMPLIANCE
                });
            }
        }
    }, [selectedProjData.l2_Indexes]);

    useEffect(() => {
        if (!_.isEmpty(selectedProjData.l3_Indexes) && selectedProjData.l3_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.l3_Indexes[complianceMainTabActive])) {
                if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].l4_Indexes.length !== 0 &&
                    currentProj.l4_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l4_Indexes[complianceMainTabActive])) {
                    handleIndexProjData('l4_Indexes');
                } else if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 &&
                    currentProj.independentIndexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.independentIndexes[complianceMainTabActive]) &&
                    (_.isEmpty(selectedProjData.independentIndexes) || (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] === undefined))) {
                    handleIndexProjData('independentIndexes');
                } else {
                    // reset after setting
                    filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                    filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                    if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                        compSearchData.current.isInitialReq = true
                        compSearchData.current.isNewRequest = true;
                        compSearchData.current.paginationReset = true;
                        applyData();
                    } else {
                        if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                            applyData();
                        } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                            let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                            if(isFilterOnChange.current){ //onchange selection
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    setGo({ ...go, isDisabled: false });
                                    //if drawer open, check changes done on drawers or not for submit btn disable
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, submitBtnDisable: false })
                                    } else { //large screen devices
                                        if(drawerData.visibility){
                                            let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                            if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                                setDrawerData({ ...drawerData, submitBtnDisable: false });
                                            } else { // if no change than previous selection
                                                setDrawerData({ ...drawerData, submitBtnDisable: true });
                                            }
                                        }
                                    }
                                } else { // if no change than previously applied selection
                                    compSearchData.current.isNewRequest = false;
                                    compSearchData.current.paginationReset = false;
                                    setGo({ ...go, isDisabled: true });
                                    setDrawerData({ ...drawerData, submitBtnDisable: true })
                                }
                                isFilterOnChange.current = false;
                            } else { //tab change/drawer cancel clicked
                                if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                    setDrawerData({ ...drawerData, dataReset: false });
                                    /** checking whether filters out of drawer has changed*/
                                    if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                        compSearchData.current.isNewRequest = true;
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                            if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                                let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                if(stringifiedFilterData !== stringifiedInitFilterData){
                                                    compSearchData.current.paginationReset = true;
                                                }
                                            }
                                        }
                                        setGo({ ...go, isDisabled: false });
                                    } else { // if no change than previously applied selection
                                        setGo({ ...go, isDisabled: true });
                                    }
                                } else { // tab change
                                    let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                    if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                        setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                    } else {//if selections not changed than initial
                                        setReset({ ...reset, visibility: false, resetApplied: false });
                                    }
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                    }
                                }
                            }
                            dispatch(controlledComponentsActions.setLoaderStatus(false));
                            // if (compSearchData.current.isNewRequest === false) { //if tab change not for the 1st time
                            //     if (go.isDisabled) {
                            //         let filtersChangedCount = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                            //         if (filtersChangedCount > 0) {//if changed than initial selections
                            //             setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                            //         } else {//if selections not changed than initial
                            //             setReset({ ...reset, visibility: false, resetApplied: false });
                            //         }
                            //     }
                            // }
                            // if (width >= 992) { // large screen devices of tab change
                            //     dispatch(controlledComponentsActions.setLoaderStatus(false));
                            //     if (drawerData.dataReset === true) { //drawer cancel clicked
                            //         filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                            //         setDrawerData({ ...drawerData, dataReset: false });
                            //     }
                            // } else if (width < 992) { // small screen devices
                            //     if (drawerData.visibility === true && drawerData.dataApplied === false && drawerData.dataReset === false) { // filter onchange done while drawer opened - Go button not clicked
                            //         dispatch(controlledComponentsActions.setLoaderStatus(false));
                            //     } else if (drawerData.visibility === false && drawerData.dataApplied === false && drawerData.dataReset === true) { // reset data by clicking close icon or cancel button in the drawer
                            //         setDrawerData({ ...drawerData, dataReset: false });
                            //         dispatch(controlledComponentsActions.setLoaderStatus(false));
                            //     } else if (drawerData.visibility === false && drawerData.dataApplied === false && drawerData.dataReset === false /*&& filterUpdatedData.current.filterDataReplace === false*/) { // small screen devices of tab change
                            //         setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                            //         dispatch(controlledComponentsActions.setLoaderStatus(false));
                            //     }
                            // }
                        }
                    }
                }
            } else {
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No selection on third level filters",
                    app: apps.COMPLIANCE
                });
            }
        }
    }, [selectedProjData.l3_Indexes]);

    useEffect(() => {
        if (!_.isEmpty(selectedProjData.l4_Indexes) && selectedProjData.l4_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.l4_Indexes[complianceMainTabActive])) {
                if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].l5_Indexes.length !== 0 &&
                    currentProj.l5_Indexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.l5_Indexes[complianceMainTabActive])) {
                    handleIndexProjData('l5_Indexes');
                } else if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 &&
                    currentProj.independentIndexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.independentIndexes[complianceMainTabActive]) &&
                    (_.isEmpty(selectedProjData.independentIndexes) || (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] === undefined))) {
                    handleIndexProjData('independentIndexes');
                } else {
                    // reset after setting
                    filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                    filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                    if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                        compSearchData.current.isInitialReq = true
                        compSearchData.current.isNewRequest = true;
                        compSearchData.current.paginationReset = true;
                        applyData();
                    } else {
                        if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                            applyData();
                        } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                            let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                            if(isFilterOnChange.current){ //onchange selection
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    setGo({ ...go, isDisabled: false });
                                    //if drawer open, check changes done on drawers or not for submit btn disable
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, submitBtnDisable: false })
                                    } else { //large screen devices
                                        if(drawerData.visibility){
                                            let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                            if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                                setDrawerData({ ...drawerData, submitBtnDisable: false });
                                            } else { // if no change than previous selection
                                                setDrawerData({ ...drawerData, submitBtnDisable: true });
                                            }
                                        }
                                    }
                                } else { // if no change than previously applied selection
                                    compSearchData.current.isNewRequest = false;
                                    compSearchData.current.paginationReset = false;
                                    setGo({ ...go, isDisabled: true });
                                    setDrawerData({ ...drawerData, submitBtnDisable: true })
                                }
                                isFilterOnChange.current = false;
                            } else { //tab change/drawer cancel clicked
                                if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                    setDrawerData({ ...drawerData, dataReset: false });
                                    /** checking whether filters out of drawer has changed*/
                                    if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                        compSearchData.current.isNewRequest = true;
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                            if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                                let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                if(stringifiedFilterData !== stringifiedInitFilterData){
                                                    compSearchData.current.paginationReset = true;
                                                }
                                            }
                                        }
                                        setGo({ ...go, isDisabled: false });
                                    } else { // if no change than previously applied selection
                                        setGo({ ...go, isDisabled: true });
                                    }
                                } else { // tab change
                                    let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                    if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                        setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                    } else {//if selections not changed than initial
                                        setReset({ ...reset, visibility: false, resetApplied: false });
                                    }
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                    }
                                }
                            }
                            dispatch(controlledComponentsActions.setLoaderStatus(false));
                        }
                    }
                }
            } else {
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No selection on forth level filters",
                    app: apps.COMPLIANCE
                });
            }
        }
    }, [selectedProjData.l4_Indexes]);

    useEffect(() => {
        if (!_.isEmpty(selectedProjData.l5_Indexes) && selectedProjData.l5_Indexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.l5_Indexes[complianceMainTabActive])) {
                if (currentIndexes[complianceMainTabActive] !== undefined && currentIndexes[complianceMainTabActive].independentIndexes.length !== 0 &&
                    currentProj.independentIndexes[complianceMainTabActive] !== undefined && !_.isEmpty(currentProj.independentIndexes[complianceMainTabActive]) &&
                    (_.isEmpty(selectedProjData.independentIndexes) || (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] === undefined))) {
                    handleIndexProjData('independentIndexes');
                } else {
                    // reset after setting
                    filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                    filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                    if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                        compSearchData.current.isInitialReq = true
                        compSearchData.current.isNewRequest = true;
                        compSearchData.current.paginationReset = true;
                        applyData();
                    } else {
                        if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                            applyData();
                        } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                            let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                            if(isFilterOnChange.current){ //onchange selection
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    setGo({ ...go, isDisabled: false });
                                    //if drawer open, check changes done on drawers or not for submit btn disable
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, submitBtnDisable: false })
                                    } else { //large screen devices
                                        if(drawerData.visibility){
                                            let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                            if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                                setDrawerData({ ...drawerData, submitBtnDisable: false });
                                            } else { // if no change than previous selection
                                                setDrawerData({ ...drawerData, submitBtnDisable: true });
                                            }
                                        }
                                    }
                                } else { // if no change than previously applied selection
                                    compSearchData.current.isNewRequest = false;
                                    compSearchData.current.paginationReset = false;
                                    setGo({ ...go, isDisabled: true });
                                    setDrawerData({ ...drawerData, submitBtnDisable: true })
                                }
                                isFilterOnChange.current = false;
                            } else { //tab change/drawer cancel clicked
                                if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                    setDrawerData({ ...drawerData, dataReset: false });
                                    /** checking whether filters out of drawer has changed*/
                                    if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                        compSearchData.current.isNewRequest = true;
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                            if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                                let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                                if(stringifiedFilterData !== stringifiedInitFilterData){
                                                    compSearchData.current.paginationReset = true;
                                                }
                                            }
                                        }
                                        setGo({ ...go, isDisabled: false });
                                    } else { // if no change than previously applied selection
                                        setGo({ ...go, isDisabled: true });
                                    }
                                } else { // tab change
                                    let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                    if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                        setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                    } else {//if selections not changed than initial
                                        setReset({ ...reset, visibility: false, resetApplied: false });
                                    }
                                    if (width < 992) { // small screen devices
                                        setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                    }
                                }
                            }
                            dispatch(controlledComponentsActions.setLoaderStatus(false));
                        }
                    }
                }
            } else {
                printError({
                    display: true,
                    err: true,
                    errCode: "Error",
                    errType: "messageErr",
                    errMsg: "No selection on fifth level filters",
                    app: apps.COMPLIANCE
                });
            }
        }
    }, [selectedProjData.l5_Indexes]);

    useEffect(() => {
        if (!_.isEmpty(selectedProjData.independentIndexes) && selectedProjData.independentIndexes[complianceMainTabActive] !== undefined) {
            if (!_.isEmpty(selectedProjData.independentIndexes[complianceMainTabActive])) {
                // reset after setting
                filterUpdatedData.current.selectedProjDataChanged.isChanged = false;
                filterUpdatedData.current.selectedProjDataChanged.changedData = {};
                if (reset.resetApplied) { //if reset butn clicked - set to initial loaded selections
                    compSearchData.current.isInitialReq = true
                    compSearchData.current.isNewRequest = true;
                    compSearchData.current.paginationReset = true;
                    applyData();
                } else {
                    if (compSearchData.current.isInitialReq === true) { // onLoad of data/inital time tab change
                        applyData();
                    } else if (compSearchData.current.isInitialReq === false) { //Tab change/onchange selection/drawer cancel clicked
                        let filtersChangedCountWithPrevApplied = getFiltersSelectionChangesCount(selectedProjData, appliedSelectedProjData);
                        if(isFilterOnChange.current){ //onchange selection
                            if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                setGo({ ...go, isDisabled: false });
                                //if drawer open, check changes done on drawers or not for submit btn disable
                                if (width < 992) { // small screen devices
                                    setDrawerData({ ...drawerData, submitBtnDisable: false })
                                } else { //large screen devices
                                    if(drawerData.visibility){
                                        let drawerFiltersChangedCount = getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen);
                                        if (drawerFiltersChangedCount > 0) {//if changed than previous selections
                                            setDrawerData({ ...drawerData, submitBtnDisable: false });
                                        } else { // if no change than previous selection
                                            setDrawerData({ ...drawerData, submitBtnDisable: true });
                                        }
                                    }
                                }
                            } else { // if no change than previously applied selection
                                compSearchData.current.isNewRequest = false;
                                compSearchData.current.paginationReset = false;
                                setGo({ ...go, isDisabled: true });
                                setDrawerData({ ...drawerData, submitBtnDisable: true })
                            }
                            isFilterOnChange.current = false;
                        } else { //tab change/drawer cancel clicked
                            if (drawerData.dataReset) { // if drawer cancel btn clicked to reset values in drawer filters
                                filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                                setDrawerData({ ...drawerData, dataReset: false });
                                /** checking whether filters out of drawer has changed*/
                                if (filtersChangedCountWithPrevApplied > 0) {//if changed than previously applied selections
                                    compSearchData.current.isNewRequest = true;
                                    if(selectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive] !== undefined ){
                                        if(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined && appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels'] !== undefined ){
                                            let stringifiedFilterData = JSON.stringify(selectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                            let stringifiedInitFilterData = JSON.stringify(appliedSelectedProjData['l1_Indexes'][complianceMainTabActive]['Hotels']);
                                            if(stringifiedFilterData !== stringifiedInitFilterData){
                                                compSearchData.current.paginationReset = true;
                                            }
                                        }
                                    }
                                    setGo({ ...go, isDisabled: false });
                                } else { // if no change than previously applied selection
                                    setGo({ ...go, isDisabled: true });
                                }
                            } else { // tab change
                                let filtersChangedCountWithInit = getFiltersSelectionChangesCount(selectedProjData, initialSelectedProjData);
                                if (filtersChangedCountWithInit > 0) {//if changed than initial selections
                                    setReset({ ...reset, visibility: true, resetApplied: false }); //show reset btn in page
                                } else {//if selections not changed than initial
                                    setReset({ ...reset, visibility: false, resetApplied: false });
                                }
                                if (width < 992) { // small screen devices
                                    setDrawerData({ ...drawerData, dataAppliedCount: getDrawerFiltersChangesCount() });
                                }
                            }
                        }
                        dispatch(controlledComponentsActions.setLoaderStatus(false));
                    }
                }
            } else {
                // printError({
                //     display: true,
                //     err: true,
                //     errCode: "Error",
                //     errType: "messageErr",
                //     errMsg: "No selection on independent filters",
                //     app: apps.COMPLIANCE
                // });
            }
        }
    }, [selectedProjData.independentIndexes]);

    useEffect(() => {
        if (!_.isEmpty(triggeredFilterData) &&
            (triggeredFilterData.key !== undefined && triggeredFilterData.selectedOption !== undefined &&
                triggeredFilterData.valuesType !== undefined && triggeredFilterData.type !== undefined &&
                triggeredFilterData.indexCategory !== undefined && triggeredFilterData.additionalData !== undefined &&
                triggeredFilterData.actualApply !== undefined
            )
        ) {
            resetSessData();
            dispatch(controlledComponentsActions.setLoaderStatus(true));
            if (triggeredFilterData.actualApply) {
                compSearchData.current.isNewRequest = true;
                if (triggeredFilterData.valuesType === "HMG") {
                    compSearchData.current.isInitialReq = true;
                    compSearchData.current.paginationReset = true;
                    setGo({ ...go, dataApplied: false, isDisabled: true });
                    handleHMG(triggeredFilterData.selectedOption);
                } else if (triggeredFilterData.valuesType === "Solution") {
                    compSearchData.current.isInitialReq = true;
                    compSearchData.current.paginationReset = true;
                    setGo({ ...go, dataApplied: false, isDisabled: true });
                    handleSol(triggeredFilterData.selectedOption)
                } else {
                    isFilterOnChange.current = true;
                    if (triggeredFilterData.indexCategory === 'l1_Indexes' && triggeredFilterData.valuesType === 'Hotels') {
                        compSearchData.current.paginationReset = true;
                    }
                    //TODO-
                    //compare with drawer filters and if changeof drawer filter mark isDrawerFilterChangeReq=true
                    //if change occure on page filters mark isDrawerFilterChangeReq=false
                    //capture drawer selection data at default data set - compare that for more prefered boolean
                    // else if (styledFilter.pageFilters.find(dr => dr.indexName === triggeredFilterData.key) !== undefined) {
                    //     filterUpdatedData.current.isDrawerFilterChangeReq = false;
                    // }

                    // if (styledFilter.drawerFilters.find(dr => dr.props.indexName === triggeredFilterData.key) !== undefined) { //if onChange occured in a drawer filter=> make go/save & close btn enable
                    //     setDrawerData({ ...drawerData, submitBtnDisable: false })
                    // }
                    // setGo({ ...go, isDisabled: false });
                    compSearchData.current.isInitialReq = false;
                    handleIndexProjData(
                        triggeredFilterData.indexCategory,
                        triggeredFilterData.key,
                        triggeredFilterData.selectedOption,
                        triggeredFilterData.valuesType,
                        triggeredFilterData.type
                    )
                }

            }
        }
    }, [triggeredFilterData]);

    // selectedProjData usereducer => action (onchange,onload,clear=initial val,reset=prev val)
    useLayoutEffect(() => {
        if (filterObjs.length !== 0) {
            let styledFilterObjs = [];
            let remainingFilterObjs = [];
            let shiftedFilterObjs = [];
            let tempstyledFilterButton = {};
            let tempstyledFilterClearButton = {};
            let tempstyledFilterGoButton = {};
            const chunkSize = (width >= 992) ? 3 : 1; //max count of page filters
            let pageSize = 0;

            remainingFilterObjs = filterObjs.slice(0, chunkSize);//page filters
            if (filterObjs.length - chunkSize > 0) {
                shiftedFilterObjs = filterObjs.slice(chunkSize, filterObjs.length);//drawer filters
            }

            if (shiftedFilterObjs.length !== 0) { // if drawer filters availble
                tempstyledFilterButton = ( // filterbtn
                    <Col
                        key="col_comp_search_filterbtn"
                        className="col_search_filterbtn"
                        xs={3} sm={3} md={2} lg={1} xl={1} xxl={1}
                    >
                        {(drawerData.dataAppliedCount < 1) ? ( // if data not applied - no badge count on filterbtn
                            <Button onClick={() => setDrawerData({
                                ...drawerData,
                                visibility: true,
                                dataApplied: false,
                                dataReset: false,
                                submitBtnDisable: true,
                                closeBtnDisable: false
                            })} icon={<MUIFilterListIcon />}></Button>
                        ) : ( // if data applied - badge count on filterbtn
                            <Badge
                                count={drawerData.dataAppliedCount}
                                style={{ backgroundColor: "#3b6cb4" }} offset={[-10, 15]} size="small">
                                <Button onClick={() => setDrawerData({
                                    ...drawerData,
                                    visibility: true,
                                    dataApplied: false,
                                    dataReset: false,
                                    submitBtnDisable: true,
                                    closeBtnDisable: false
                                })} icon={<MUIFilterListIcon />}></Button>
                            </Badge>
                        )}
                    </Col>
                );

                if (reset.visibility) { // if data applied - show Reset/Clear btn lg21
                    tempstyledFilterClearButton = (
                        <Col
                            key="col_comp_search_filterclarbtn"
                            className='col_search_filterclarbtn'
                            xs={4} sm={4} md={2} lg={2} xl={1} xxl={1}
                        >
                            <Button type="link"
                                className='btn_filterClear'
                                size='small'
                                onClick={() => setReset({
                                    ...reset,
                                    resetApplied: true
                                })}
                            >
                                Reset
                            </Button>
                        </Col>
                    );
                    if (width >= 992) {
                        pageSize = (width < 1200) ? 19 : ((width < 1600) ? 20 : 21)
                    } else {
                        styledFilterObjs.push(
                            <Col
                                key={"col_" + remainingFilterObjs.key}
                                xs={17} sm={17} md={12}
                            // span={12}
                            >{remainingFilterObjs}</Col>
                        );
                    }
                } else { //if data not applied- no reset/clear btn lg22
                    if (width >= 992) {
                        pageSize = (width < 1200) ? 21 : ((width < 1600) ? 21 : 22);

                    } else {
                        styledFilterObjs.push(
                            <Col
                                key={"col_" + remainingFilterObjs.key}
                                xs={21} sm={21} md={12}
                            // span={12}
                            >{remainingFilterObjs}</Col>
                        );
                    }
                }
                if (width >= 992) { // large screens - if go btn
                    tempstyledFilterGoButton = (
                        <Col
                            key={"col_comp_search_gobtn"}
                            className='col_search_gobtn'
                            lg={2} xl={2} xxl={1}
                        >
                            <Button
                                onClick={() => setGo({ dataApplied: true, isDisabled: true })}
                                disabled={go.isDisabled}
                                className="comp_search_gobtn"
                            >
                                Go
                            </Button>
                        </Col>
                    );
                }

            } else { // if drawer filters not availble lg23
                if (width >= 992) { // large screens - if remainingFilterObjs less than 2 => no go btn, else=> go btn
                    if (remainingFilterObjs.length > 1) {
                        tempstyledFilterGoButton = (
                            <Col
                                key={"col_comp_search_gobtn"}
                                className='col_search_gobtn'
                                lg={2} xl={2} xxl={1}
                            >
                                <Button
                                    onClick={() => setGo({ dataApplied: true, isDisabled: true })}
                                    disabled={go.isDisabled}
                                    className="comp_search_gobtn"
                                >
                                    Go
                                </Button>
                            </Col>);
                        if (reset.visibility) { // if data applied - show Reset/Clear btn lg21
                            tempstyledFilterClearButton = (
                                <Col
                                    key="col_comp_search_filterclarbtn"
                                    className="col_search_filterclarbtn"
                                    xs={4} sm={4} md={2} lg={2} xl={1} xxl={1}
                                >
                                    <Button type="link"
                                        className='btn_filterClear'
                                        size='small'
                                        onClick={() => setReset({
                                            ...reset,
                                            resetApplied: true
                                        })}
                                    >
                                        Reset
                                    </Button>
                                </Col>
                            );
                            pageSize = (width < 1200) ? 20 : ((width < 1600) ? 21 : 22);
                        } else {
                            pageSize = (width < 1200) ? 22 : ((width < 1600) ? 22 : 23);
                        }
                    } else {
                        pageSize = 24
                    }
                } else { //small screens - filterbtn disable
                    tempstyledFilterButton = ( //filterbtn
                        <Col
                            key="col_comp_search_filterbtn"
                            className="col_search_filterbtn"
                            xs={3} sm={3} md={2}
                        >
                            <Button disabled={true} icon={<MUIFilterListIcon />}></Button>
                        </Col>
                    );
                    styledFilterObjs.push( //page filter
                        <Col
                            key={"col_" + remainingFilterObjs.key}
                            style={{ paddingBottom: '8px' }}
                            xs={21} sm={21} md={12}
                        >{remainingFilterObjs}</Col>
                    );
                }

            }
            if (width >= 992) {
                let colSpan = pageFilterColSpan(remainingFilterObjs, pageSize);
                for (let index = 0; index < remainingFilterObjs.length; index++) {
                    const element = remainingFilterObjs[index];
                    styledFilterObjs.push(
                        (<Col
                            key={"col_" + element.key}
                            span={(element.props.mode === 'multiple') ? colSpan.multiModeColSpan : colSpan.singleModeColSpan}
                        >{element}</Col>));
                }
            }

            if (!_.isEmpty(tempstyledFilterGoButton)) {
                styledFilterObjs.push(tempstyledFilterGoButton);
            }
            if (!_.isEmpty(tempstyledFilterButton)) {
                styledFilterObjs.push(tempstyledFilterButton);
            }
            if (!_.isEmpty(tempstyledFilterClearButton)) {
                styledFilterObjs.push(tempstyledFilterClearButton);
            }
            let tempstyledFilter = { 'pageFilters': styledFilterObjs, 'drawerFilters': shiftedFilterObjs }
            setStyledFilter(tempstyledFilter);
        }
    }, [width, filterObjs, go, drawerData.dataAppliedCount, reset]);

    useLayoutEffect(() => {//TODO : work on filter count when switching
        if (width >= 992) { // large devices
            if (!go.isDisabled) { // when change from small screen to large screen if Go button is enabled,
                if (triggeredFilterData.key !== undefined) { //TODO: this is not correct if multiple on changes done
                    if (styledFilter.drawerFilters.find(dr => dr.props.indexName === triggeredFilterData.key) !== undefined && !drawerData.submitBtnDisable) { //if onChange occured in a drawer filter=> make go/save & close btn enable and open drawer
                        setDrawerData({ ...drawerData, visibility: true, submitBtnDisable: false })
                    } else { // else consider as onchange occured in a page filter of large screen- close drawer and disable save & close btn
                        setDrawerData({ ...drawerData, visibility: false, submitBtnDisable: true });
                    }
                } else {  //close the drawer and disable submit button, though drawer availble or not
                    setDrawerData({ ...drawerData, visibility: false, submitBtnDisable: true });
                }
            }
        } else { //small devices
            if (!go.isDisabled) { // when change from large screen to small screen if Go button is enabled, open the drawer and enable submit button to submit the changes
                setDrawerData({ ...drawerData, visibility: true, submitBtnDisable: false });
            }
        }

    }, [width])

    useLayoutEffect(() => {
        if (width >= 992) { // large screen devices
            if (drawerData.visibility && !drawerData.dataApplied && !drawerData.dataReset && drawerData.submitBtnDisable) {
                filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = { ...selectedProjData }//clear this value when drawerData.dataReset=false and drawerData.dataApplied
            } else if (drawerData.dataReset) { //when drawer 'Cancel' btn clicked
                dispatch(controlledComponentsActions.setLoaderStatus(true));
                if (getFiltersSelectionChangesCount(selectedProjData, filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen) > 0) { //changes occured in drawer filters
                    let copyOfInitialSelectedProjDataOnDrawerOpen = JSON.parse(JSON.stringify(filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen));
                    if (copyOfInitialSelectedProjDataOnDrawerOpen.l1_Indexes[complianceMainTabActive] !== undefined || copyOfInitialSelectedProjDataOnDrawerOpen.independentIndexes[complianceMainTabActive] !== undefined) {
                        filterUpdatedData.current.selectedProjDataChanged.isChanged = true;
                        filterUpdatedData.current.selectedProjDataChanged.changedData = copyOfInitialSelectedProjDataOnDrawerOpen;
                    }
                    handleHMG(currentHMG.hmg);
                } else { //changes not occured in drawer filters
                    filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                    dispatch(controlledComponentsActions.setLoaderStatus(false));
                    setDrawerData({ ...drawerData, dataReset: false });
                }

            } else if (drawerData.dataApplied) { //when drawer 'Go' btn/ 'Save and Close' btn clicked
                filterUpdatedData.current.initialSelectedProjDataOnDrawerOpen = {};
                setDrawerData({ ...drawerData, dataApplied: false });
                dispatch(controlledComponentsActions.setLoaderStatus(false));
            }
        } else { //small screen devices
            if (drawerData.dataApplied === true) { //when drawer 'Go' btn/ 'Save and Close' btn clicked
                dispatch(controlledComponentsActions.setLoaderStatus(true));
                applyData();
            } else if (drawerData.dataReset === true) { //when drawer 'Cancel' btn clicked
                dispatch(controlledComponentsActions.setLoaderStatus(true));
                if (!compSearchData.current.isNewRequest) { //if change not done in drawer filters
                    dispatch(controlledComponentsActions.setLoaderStatus(false));
                    setDrawerData({ ...drawerData, dataReset: false });
                } else { //if change done in drawer filters
                    let copyOfappliedSelectedProjData = JSON.parse(JSON.stringify(appliedSelectedProjData));
                    let SelectedExtraProjDataKeys = Object.keys(selectedExtraProjData);
                    delete copyOfappliedSelectedProjData.appConfigSoftLiveType;
                    delete copyOfappliedSelectedProjData.altSearchIdx;
                    if (copyOfappliedSelectedProjData.l1_Indexes[complianceMainTabActive] !== undefined || copyOfappliedSelectedProjData.independentIndexes[complianceMainTabActive] !== undefined) {
                        filterUpdatedData.current.selectedProjDataChanged.isChanged = true;
                        filterUpdatedData.current.selectedProjDataChanged.changedData = copyOfappliedSelectedProjData;
                    }
                    handleHMG(currentHMG.hmg);
                    // setGo({ ...go, isDisabled: true });
                }
            }
        }
    }, [drawerData]);

    useEffect(() => {
        if (groupingModalData.groupingModalOpen && !_.isEmpty(groupingModalData.groupingModalData)) {
            if (groupingModalData.groupingModalData.modalType === modalConfigs.modalType.FILTER_SEC_GROUPING) { // grouping modal of filters like hotel
                let modalTitle = `${groupingModalData.groupingModalData.groupingAction} ${groupingModalData.groupingModalData.indexName} Group`;
                let modalData = {
                    mappingList: [],
                    allGroupData: [],
                    currentGroupData: {},
                    // isCurrentGroupSelected: groupingModalData.groupingModalData.isGroupSelected,
                    index: {
                        indexName: groupingModalData.groupingModalData.indexName,
                        indexValueType: groupingModalData.groupingModalData.indexValueType
                    },
                    userName: loggedUserData.rawUserName,
                    entityId: currentHMG.entityId,
                    projectId: currentSol[complianceMainTabActive].projId,
                    action: groupingModalData.groupingModalData.groupingAction
                };
                let modalType = groupingModalData.groupingModalData.modalType;
                for (const levl in currentProj) {
                    if (!_.isEmpty(currentProj[levl]) && (currentProj[levl][complianceMainTabActive] !== undefined && !_.isEmpty(currentProj[levl][complianceMainTabActive]))) {
                        const indexList = currentProj[levl][complianceMainTabActive];
                        const filtered = Object.keys(indexList)
                            .filter(key => key === groupingModalData.groupingModalData.indexName)
                            .reduce((obj, key) => {
                                obj[key] = indexList[key];
                                return obj;
                            }, {});
                        if (!_.isEmpty(filtered)) {
                            modalData.mappingList = filtered[groupingModalData.groupingModalData.indexName].singleData;
                            modalData.allGroupData = filtered[groupingModalData.groupingModalData.indexName].groupedData;
                            modalData.currentGroupData = filtered[groupingModalData.groupingModalData.indexName].groupedData.find(g => g.groupId === groupingModalData.groupingModalData.groupId && g.userGroupId === groupingModalData.groupingModalData.userGroupId)
                            break;
                        }
                    }
                    continue;
                }
                setModalData({
                    visibility: true,
                    type: modalType,
                    title: modalTitle,
                    data: modalData
                });
            }
        } else if (!groupingModalData.groupingModalOpen) { //temp
            setModalData({
                visibility: false,
                type: "",
                title: "",
                data: {}
            });
        }


    }, [groupingModalData.groupingModalOpen])

    useEffect(() => {
        if (go.dataApplied) {
            dispatch(controlledComponentsActions.setLoaderStatus(true));
            applyData();
        }
    }, [go])

    useEffect(() => {
        if (reset.resetApplied) {
            dispatch(controlledComponentsActions.setLoaderStatus(true));
            clearFilterData();
        }
    }, [reset])

    useLayoutEffect(() => {
        if (errorObject.errType !== "" && errorObject.errType !== 'pageErr') {
            setErrorObject({
                err: false,
                errCode: "",
                errType: "",
                errMsg: "",
                display: false,
                app: apps.COMPLIANCE
            });
            dispatch(controlledComponentsActions.setLoaderStatus(false));
        }
    }, [errorObject])

    return (
        <div className={props.className}>
            {(errorObject.display === true && errorObject.errType !== "pageErr" ?
                <QMSErrorHandle errordetails={errorObject} />
                : "")}
            <CustomModal
                name="comp_search_grouping_modal"
                type={modalData.type}
                title={modalData.title}
                data={modalData.data}
                closeCallback={{ type: 'button', label: 'Cancel', callback: setModalData, actionType: modalConfigs.modalBtnTypes.CLOSE }}
                submitCallback={{ type: 'button_primary', label: 'Save', callback: setUpdatedCurrentProjData, actionType: modalConfigs.modalBtnTypes.SUBMIT }}
                visible={modalData.visibility}
                width=""
                className=""
            ></CustomModal>
            <Row
                gutter={width < 1024 ? [4, 8] : (width < 1200 ? [8, 8] : [12, 8])}
                align="bottom">
                {styledFilter.pageFilters}
            </Row>
            {
                styledFilter.drawerFilters.length !== 0 ?
                    <CustomDrawer
                        name="comp_search_filterDrawer"
                        data={{
                            type: drawerConfigs.drawerType.FILTER,
                            bodyData: styledFilter.drawerFilters
                        }}
                        title="Filters"
                        closeCallback={{
                            type: 'button',
                            label: 'Cancel',
                            isDisable: drawerData.closeBtnDisable,
                            callback: drawerCloseFunc,
                            actionType: drawerConfigs.drawerBtnTypes.RESET
                        }}
                        submitCallback={{
                            type: 'button_primary',
                            label: (width >= 992 ? 'Save and Close' : 'Go'),
                            isDisable: drawerData.submitBtnDisable,
                            callback: drawerCloseFunc,
                            // (updatedProps) => {
                            //     let filtersChangedCount = getDrawerFiltersChangesCount();
                            //     let merged = _.merge(updatedProps, { dataAppliedCount: filtersChangedCount });
                            //     setDrawerData(merged);
                            // },
                            actionType: drawerConfigs.drawerBtnTypes.SUBMIT
                        }}
                        placement="right"
                        visible={drawerData.visibility}
                        width={width >= 992 ? '35%' : (width >= 768 && width < 992 ? '50%' : (width <= 425 ? '100%' : '75%'))}
                        className={props.className}
                    />
                    : ""
            }
        </div>
    );
}

export default React.memo(HotelBaseComplianceFilterSection)
